
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("gQ473", function(module, exports) {
$parcel$export(module.exports, "default", () => $c424b15dbb70775f$export$2e2bcd8739ae039);

var $3yGK6 = parcelRequire("3yGK6");


var $37zWd = parcelRequire("37zWd");

function $c424b15dbb70775f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $3yGK6.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $37zWd.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $37zWd.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});

parcelRegister("8EGKX", function(module, exports) {
var $2eae201db41c8ad0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "p\u0159ed sekundou",
            future: 'za sekundu'
        },
        few: {
            regular: '{{count}} sekundy',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekundy'
        },
        many: {
            regular: '{{count}} sekund',
            past: "p\u0159ed {{count}} sekundami",
            future: 'za {{count}} sekund'
        }
    },
    halfAMinute: {
        type: 'other',
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "p\u0159ed minutou",
            future: 'za minutu'
        },
        few: {
            regular: '{{count}} minuty',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minuty'
        },
        many: {
            regular: '{{count}} minut',
            past: "p\u0159ed {{count}} minutami",
            future: 'za {{count}} minut'
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: 'hodina',
            past: "p\u0159ed hodinou",
            future: 'za hodinu'
        },
        few: {
            regular: '{{count}} hodiny',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodiny'
        },
        many: {
            regular: '{{count}} hodin',
            past: "p\u0159ed {{count}} hodinami",
            future: 'za {{count}} hodin'
        }
    },
    xDays: {
        one: {
            regular: 'den',
            past: "p\u0159ed dnem",
            future: 'za den'
        },
        few: {
            regular: '{{count}} dny',
            past: "p\u0159ed {{count}} dny",
            future: 'za {{count}} dny'
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: 'rok',
            past: "p\u0159ed rokem",
            future: 'za rok'
        },
        few: {
            regular: '{{count}} roky',
            past: "p\u0159ed {{count}} roky",
            future: 'za {{count}} roky'
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: 'skoro rok',
            past: "skoro p\u0159ed rokem",
            future: 'skoro za rok'
        },
        few: {
            regular: 'skoro {{count}} roky',
            past: "skoro p\u0159ed {{count}} roky",
            future: 'skoro za {{count}} roky'
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var $2eae201db41c8ad0$var$formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = $2eae201db41c8ad0$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === 'other') pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace('{{count}}', String(count));
};
var $2eae201db41c8ad0$export$2e2bcd8739ae039 = $2eae201db41c8ad0$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $c9270e9352c5dab6$var$dateFormats = {
    full: 'EEEE, d. MMMM yyyy',
    long: 'd. MMMM yyyy',
    medium: 'd. M. yyyy',
    short: 'dd.MM.yyyy'
};
var $c9270e9352c5dab6$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $c9270e9352c5dab6$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $c9270e9352c5dab6$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $c9270e9352c5dab6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $c9270e9352c5dab6$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $c9270e9352c5dab6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $c9270e9352c5dab6$export$2e2bcd8739ae039 = $c9270e9352c5dab6$var$formatLong;


var $6549fe45c9b430e5$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    'sobotu'
];
var $6549fe45c9b430e5$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + $6549fe45c9b430e5$var$accusativeWeekdays[day] + " o' p";
    },
    other: 'P'
};
var $6549fe45c9b430e5$var$formatRelative = function formatRelative(token, date) {
    var format = $6549fe45c9b430e5$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $6549fe45c9b430e5$export$2e2bcd8739ae039 = $6549fe45c9b430e5$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $a2ecfd2abd34f6a8$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    abbreviated: [
        "p\u0159. n. l.",
        'n. l.'
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var $a2ecfd2abd34f6a8$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var $a2ecfd2abd34f6a8$var$monthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'leden',
        "\xfanor",
        "b\u0159ezen",
        'duben',
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        'srpen',
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        'listopad',
        'prosinec'
    ]
};
var $a2ecfd2abd34f6a8$var$formattingMonthValues = {
    narrow: [
        'L',
        "\xda",
        'B',
        'D',
        'K',
        "\u010C",
        "\u010C",
        'S',
        'Z',
        "\u0158",
        'L',
        'P'
    ],
    abbreviated: [
        'led',
        "\xfano",
        "b\u0159e",
        'dub',
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        'srp',
        "z\xe1\u0159",
        "\u0159\xedj",
        'lis',
        'pro'
    ],
    wide: [
        'ledna',
        "\xfanora",
        "b\u0159ezna",
        'dubna',
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        'srpna',
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        'listopadu',
        'prosince'
    ]
};
var $a2ecfd2abd34f6a8$var$dayValues = {
    narrow: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    short: [
        'ne',
        'po',
        "\xfat",
        'st',
        "\u010Dt",
        "p\xe1",
        'so'
    ],
    abbreviated: [
        'ned',
        'pon',
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        'sob'
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        'sobota'
    ]
};
var $a2ecfd2abd34f6a8$var$dayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $a2ecfd2abd34f6a8$var$formattingDayPeriodValues = {
    narrow: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    abbreviated: {
        am: 'dop.',
        pm: 'odp.',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    },
    wide: {
        am: 'dopoledne',
        pm: 'odpoledne',
        midnight: "p\u016Flnoc",
        noon: 'poledne',
        morning: "r\xe1no",
        afternoon: 'odpoledne',
        evening: "ve\u010Der",
        night: 'noc'
    }
};
var $a2ecfd2abd34f6a8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $a2ecfd2abd34f6a8$var$localize = {
    ordinalNumber: $a2ecfd2abd34f6a8$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $a2ecfd2abd34f6a8$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a2ecfd2abd34f6a8$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a2ecfd2abd34f6a8$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a2ecfd2abd34f6a8$export$2e2bcd8739ae039 = $a2ecfd2abd34f6a8$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $8b1f531cf9c26189$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $8b1f531cf9c26189$var$parseOrdinalNumberPattern = /\d+/i;
var $8b1f531cf9c26189$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $8b1f531cf9c26189$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $8b1f531cf9c26189$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $8b1f531cf9c26189$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8b1f531cf9c26189$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $8b1f531cf9c26189$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $8b1f531cf9c26189$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $8b1f531cf9c26189$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var $8b1f531cf9c26189$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var $8b1f531cf9c26189$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $8b1f531cf9c26189$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $8b1f531cf9c26189$var$matchOrdinalNumberPattern,
        parsePattern: $8b1f531cf9c26189$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b1f531cf9c26189$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b1f531cf9c26189$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b1f531cf9c26189$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8b1f531cf9c26189$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $8b1f531cf9c26189$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8b1f531cf9c26189$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8b1f531cf9c26189$export$2e2bcd8739ae039 = $8b1f531cf9c26189$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $64d339aa97525480$var$locale = {
    code: 'cs',
    formatDistance: (0, $2eae201db41c8ad0$export$2e2bcd8739ae039),
    formatLong: (0, $c9270e9352c5dab6$export$2e2bcd8739ae039),
    formatRelative: (0, $6549fe45c9b430e5$export$2e2bcd8739ae039),
    localize: (0, $a2ecfd2abd34f6a8$export$2e2bcd8739ae039),
    match: (0, $8b1f531cf9c26189$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $64d339aa97525480$export$2e2bcd8739ae039 = $64d339aa97525480$var$locale;
module.exports["default"] = $64d339aa97525480$export$2e2bcd8739ae039;

});

parcelRegister("fIezj", function(module, exports) {
var $5d887467d929f4a1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: 'mindre end {{count}} sekunder'
    },
    xSeconds: {
        one: '1 sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: 'mindre end {{count}} minutter'
    },
    xMinutes: {
        one: '1 minut',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'cirka 1 time',
        other: 'cirka {{count}} timer'
    },
    xHours: {
        one: '1 time',
        other: '{{count}} timer'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dage'
    },
    aboutXWeeks: {
        one: 'cirka 1 uge',
        other: 'cirka {{count}} uger'
    },
    xWeeks: {
        one: '1 uge',
        other: '{{count}} uger'
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var $5d887467d929f4a1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5d887467d929f4a1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $5d887467d929f4a1$export$2e2bcd8739ae039 = $5d887467d929f4a1$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $96b6dfd15a6bf5f5$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd/MM/y'
};
var $96b6dfd15a6bf5f5$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $96b6dfd15a6bf5f5$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $96b6dfd15a6bf5f5$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $96b6dfd15a6bf5f5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $96b6dfd15a6bf5f5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $96b6dfd15a6bf5f5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $96b6dfd15a6bf5f5$export$2e2bcd8739ae039 = $96b6dfd15a6bf5f5$var$formatLong;


var $38319ff13efd02fa$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: 'P'
};
var $38319ff13efd02fa$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $38319ff13efd02fa$var$formatRelativeLocale[token];
};
var $38319ff13efd02fa$export$2e2bcd8739ae039 = $38319ff13efd02fa$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $535500b3982b29e7$var$eraValues = {
    narrow: [
        'fvt',
        'vt'
    ],
    abbreviated: [
        'f.v.t.',
        'v.t.'
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        'vesterlandsk tidsregning'
    ]
};
var $535500b3982b29e7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        '1. kvt.',
        '2. kvt.',
        '3. kvt.',
        '4. kvt.'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $535500b3982b29e7$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mar.',
        'apr.',
        'maj',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januar',
        'februar',
        'marts',
        'april',
        'maj',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $535500b3982b29e7$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        'man.',
        'tir.',
        'ons.',
        'tor.',
        'fre.',
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $535500b3982b29e7$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'morgen',
        afternoon: 'eftermiddag',
        evening: 'aften',
        night: 'nat'
    }
};
var $535500b3982b29e7$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnat',
        noon: 'middag',
        morning: 'om morgenen',
        afternoon: 'om eftermiddagen',
        evening: 'om aftenen',
        night: 'om natten'
    }
};
var $535500b3982b29e7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $535500b3982b29e7$var$localize = {
    ordinalNumber: $535500b3982b29e7$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $535500b3982b29e7$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $535500b3982b29e7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $535500b3982b29e7$export$2e2bcd8739ae039 = $535500b3982b29e7$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $9b0a569ced3d46ca$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $9b0a569ced3d46ca$var$parseOrdinalNumberPattern = /\d+/i;
var $9b0a569ced3d46ca$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $9b0a569ced3d46ca$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $9b0a569ced3d46ca$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $9b0a569ced3d46ca$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $9b0a569ced3d46ca$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $9b0a569ced3d46ca$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $9b0a569ced3d46ca$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $9b0a569ced3d46ca$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $9b0a569ced3d46ca$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $9b0a569ced3d46ca$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $9b0a569ced3d46ca$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $9b0a569ced3d46ca$var$matchOrdinalNumberPattern,
        parsePattern: $9b0a569ced3d46ca$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9b0a569ced3d46ca$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9b0a569ced3d46ca$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9b0a569ced3d46ca$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9b0a569ced3d46ca$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $9b0a569ced3d46ca$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9b0a569ced3d46ca$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9b0a569ced3d46ca$export$2e2bcd8739ae039 = $9b0a569ced3d46ca$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $b7064417012119b7$var$locale = {
    code: 'da',
    formatDistance: (0, $5d887467d929f4a1$export$2e2bcd8739ae039),
    formatLong: (0, $96b6dfd15a6bf5f5$export$2e2bcd8739ae039),
    formatRelative: (0, $38319ff13efd02fa$export$2e2bcd8739ae039),
    localize: (0, $535500b3982b29e7$export$2e2bcd8739ae039),
    match: (0, $9b0a569ced3d46ca$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b7064417012119b7$export$2e2bcd8739ae039 = $b7064417012119b7$var$locale;
module.exports["default"] = $b7064417012119b7$export$2e2bcd8739ae039;

});

parcelRegister("d42EV", function(module, exports) {

var $7rt4j = parcelRequire("7rt4j");


var $60sGp = parcelRequire("60sGp");


var $4BSGy = parcelRequire("4BSGy");


var $9v2ZC = parcelRequire("9v2ZC");

var $c4a569043fd278ad$var$eraValues = {
    narrow: [
        'v.Chr.',
        'n.Chr.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'vor Christus',
        'nach Christus'
    ]
};
var $c4a569043fd278ad$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. Quartal',
        '2. Quartal',
        '3. Quartal',
        '4. Quartal'
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $c4a569043fd278ad$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        "M\xe4r",
        'Apr',
        'Mai',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Okt',
        'Nov',
        'Dez'
    ],
    wide: [
        'Januar',
        'Februar',
        "M\xe4rz",
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember'
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $c4a569043fd278ad$var$formattingMonthValues = {
    narrow: $c4a569043fd278ad$var$monthValues.narrow,
    abbreviated: [
        'Jan.',
        'Feb.',
        "M\xe4rz",
        'Apr.',
        'Mai',
        'Juni',
        'Juli',
        'Aug.',
        'Sep.',
        'Okt.',
        'Nov.',
        'Dez.'
    ],
    wide: $c4a569043fd278ad$var$monthValues.wide
};
var $c4a569043fd278ad$var$dayValues = {
    narrow: [
        'S',
        'M',
        'D',
        'M',
        'D',
        'F',
        'S'
    ],
    short: [
        'So',
        'Mo',
        'Di',
        'Mi',
        'Do',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'So.',
        'Mo.',
        'Di.',
        'Mi.',
        'Do.',
        'Fr.',
        'Sa.'
    ],
    wide: [
        'Sonntag',
        'Montag',
        'Dienstag',
        'Mittwoch',
        'Donnerstag',
        'Freitag',
        'Samstag'
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $c4a569043fd278ad$var$dayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachm.',
        evening: 'Abend',
        night: 'Nacht'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'Morgen',
        afternoon: 'Nachmittag',
        evening: 'Abend',
        night: 'Nacht'
    }
};
var $c4a569043fd278ad$var$formattingDayPeriodValues = {
    narrow: {
        am: 'vm.',
        pm: 'nm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachm.',
        evening: 'abends',
        night: 'nachts'
    },
    abbreviated: {
        am: 'vorm.',
        pm: 'nachm.',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    },
    wide: {
        am: 'vormittags',
        pm: 'nachmittags',
        midnight: 'Mitternacht',
        noon: 'Mittag',
        morning: 'morgens',
        afternoon: 'nachmittags',
        evening: 'abends',
        night: 'nachts'
    }
};
var $c4a569043fd278ad$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $c4a569043fd278ad$var$localize = {
    ordinalNumber: $c4a569043fd278ad$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$monthValues,
        formattingValues: $c4a569043fd278ad$var$formattingMonthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $c4a569043fd278ad$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $c4a569043fd278ad$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $c4a569043fd278ad$export$2e2bcd8739ae039 = $c4a569043fd278ad$var$localize;



var $lT7Hr = parcelRequire("lT7Hr");

/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $982db62359ebe24a$var$locale = {
    code: 'de',
    formatDistance: (0, $7rt4j.default),
    formatLong: (0, $60sGp.default),
    formatRelative: (0, $4BSGy.default),
    localize: (0, $c4a569043fd278ad$export$2e2bcd8739ae039),
    match: (0, $lT7Hr.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $982db62359ebe24a$export$2e2bcd8739ae039 = $982db62359ebe24a$var$locale;
module.exports["default"] = $982db62359ebe24a$export$2e2bcd8739ae039;

});

parcelRegister("7rt4j", function(module, exports) {
var $0165f61a75650612$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        },
        withPreposition: {
            one: 'weniger als 1 Sekunde',
            other: 'weniger als {{count}} Sekunden'
        }
    },
    xSeconds: {
        standalone: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        },
        withPreposition: {
            one: '1 Sekunde',
            other: '{{count}} Sekunden'
        }
    },
    halfAMinute: {
        standalone: 'halbe Minute',
        withPreposition: 'halben Minute'
    },
    lessThanXMinutes: {
        standalone: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        },
        withPreposition: {
            one: 'weniger als 1 Minute',
            other: 'weniger als {{count}} Minuten'
        }
    },
    xMinutes: {
        standalone: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        },
        withPreposition: {
            one: '1 Minute',
            other: '{{count}} Minuten'
        }
    },
    aboutXHours: {
        standalone: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        },
        withPreposition: {
            one: 'etwa 1 Stunde',
            other: 'etwa {{count}} Stunden'
        }
    },
    xHours: {
        standalone: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        },
        withPreposition: {
            one: '1 Stunde',
            other: '{{count}} Stunden'
        }
    },
    xDays: {
        standalone: {
            one: '1 Tag',
            other: '{{count}} Tage'
        },
        withPreposition: {
            one: '1 Tag',
            other: '{{count}} Tagen'
        }
    },
    aboutXWeeks: {
        standalone: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        },
        withPreposition: {
            one: 'etwa 1 Woche',
            other: 'etwa {{count}} Wochen'
        }
    },
    xWeeks: {
        standalone: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        },
        withPreposition: {
            one: '1 Woche',
            other: '{{count}} Wochen'
        }
    },
    aboutXMonths: {
        standalone: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monate'
        },
        withPreposition: {
            one: 'etwa 1 Monat',
            other: 'etwa {{count}} Monaten'
        }
    },
    xMonths: {
        standalone: {
            one: '1 Monat',
            other: '{{count}} Monate'
        },
        withPreposition: {
            one: '1 Monat',
            other: '{{count}} Monaten'
        }
    },
    aboutXYears: {
        standalone: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahre'
        },
        withPreposition: {
            one: 'etwa 1 Jahr',
            other: 'etwa {{count}} Jahren'
        }
    },
    xYears: {
        standalone: {
            one: '1 Jahr',
            other: '{{count}} Jahre'
        },
        withPreposition: {
            one: '1 Jahr',
            other: '{{count}} Jahren'
        }
    },
    overXYears: {
        standalone: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahre'
        },
        withPreposition: {
            one: 'mehr als 1 Jahr',
            other: 'mehr als {{count}} Jahren'
        }
    },
    almostXYears: {
        standalone: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahre'
        },
        withPreposition: {
            one: 'fast 1 Jahr',
            other: 'fast {{count}} Jahren'
        }
    }
};
var $0165f61a75650612$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $0165f61a75650612$var$formatDistanceLocale[token].withPreposition : $0165f61a75650612$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return 'vor ' + result;
    }
    return result;
};
var $0165f61a75650612$export$2e2bcd8739ae039 = $0165f61a75650612$var$formatDistance;
module.exports["default"] = $0165f61a75650612$export$2e2bcd8739ae039;

});

parcelRegister("60sGp", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $45f8fdfd81128369$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    // Montag, 7. Januar 2018
    long: 'do MMMM y',
    // 7. Januar 2018
    medium: 'do MMM y',
    // 7. Jan. 2018
    short: 'dd.MM.y' // 07.01.2018
};
var $45f8fdfd81128369$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $45f8fdfd81128369$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $45f8fdfd81128369$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $45f8fdfd81128369$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $45f8fdfd81128369$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $45f8fdfd81128369$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $45f8fdfd81128369$export$2e2bcd8739ae039 = $45f8fdfd81128369$var$formatLong;
module.exports["default"] = $45f8fdfd81128369$export$2e2bcd8739ae039;

});

parcelRegister("4BSGy", function(module, exports) {
var $35b509852f1813a7$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: 'P'
};
var $35b509852f1813a7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $35b509852f1813a7$var$formatRelativeLocale[token];
};
var $35b509852f1813a7$export$2e2bcd8739ae039 = $35b509852f1813a7$var$formatRelative;
module.exports["default"] = $35b509852f1813a7$export$2e2bcd8739ae039;

});

parcelRegister("lT7Hr", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $fef4b50301223899$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $fef4b50301223899$var$parseOrdinalNumberPattern = /\d+/i;
var $fef4b50301223899$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $fef4b50301223899$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $fef4b50301223899$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $fef4b50301223899$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fef4b50301223899$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $fef4b50301223899$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $fef4b50301223899$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $fef4b50301223899$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $fef4b50301223899$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $fef4b50301223899$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $fef4b50301223899$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $fef4b50301223899$var$matchOrdinalNumberPattern,
        parsePattern: $fef4b50301223899$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $fef4b50301223899$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $fef4b50301223899$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $fef4b50301223899$export$2e2bcd8739ae039 = $fef4b50301223899$var$match;
module.exports["default"] = $fef4b50301223899$export$2e2bcd8739ae039;

});

parcelRegister("8HKXv", function(module, exports) {

var $i2iDg = parcelRequire("i2iDg");


var $7jD2r = parcelRequire("7jD2r");


var $5rCeA = parcelRequire("5rCeA");


var $4qQoY = parcelRequire("4qQoY");


var $hJozw = parcelRequire("hJozw");

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $6566c3e8a339288d$var$locale = {
    code: 'en-GB',
    formatDistance: (0, $i2iDg.default),
    formatLong: (0, $hJozw.default),
    formatRelative: (0, $7jD2r.default),
    localize: (0, $5rCeA.default),
    match: (0, $4qQoY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $6566c3e8a339288d$export$2e2bcd8739ae039 = $6566c3e8a339288d$var$locale;
module.exports["default"] = $6566c3e8a339288d$export$2e2bcd8739ae039;

});

parcelRegister("hJozw", function(module, exports) {

var $fcGXP = parcelRequire("fcGXP");

var $ce89b3180b428a97$var$dateFormats = {
    full: 'EEEE, d MMMM yyyy',
    long: 'd MMMM yyyy',
    medium: 'd MMM yyyy',
    short: 'dd/MM/yyyy'
};
var $ce89b3180b428a97$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $ce89b3180b428a97$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $ce89b3180b428a97$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $ce89b3180b428a97$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $ce89b3180b428a97$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $ce89b3180b428a97$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $ce89b3180b428a97$export$2e2bcd8739ae039 = $ce89b3180b428a97$var$formatLong;
module.exports["default"] = $ce89b3180b428a97$export$2e2bcd8739ae039;

});

parcelRegister("gDEfH", function(module, exports) {
var $77eafa43effd33b1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de un segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'medio minuto',
    lessThanXMinutes: {
        one: 'menos de un minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'alrededor de 1 hora',
        other: 'alrededor de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: 'alrededor de 1 semana',
        other: 'alrededor de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: 'alrededor de 1 mes',
        other: 'alrededor de {{count}} meses'
    },
    xMonths: {
        one: '1 mes',
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $77eafa43effd33b1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $77eafa43effd33b1$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'en ' + result;
        else return 'hace ' + result;
    }
    return result;
};
var $77eafa43effd33b1$export$2e2bcd8739ae039 = $77eafa43effd33b1$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $cb3cd1ec4cb75b63$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $cb3cd1ec4cb75b63$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $cb3cd1ec4cb75b63$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cb3cd1ec4cb75b63$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $cb3cd1ec4cb75b63$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $cb3cd1ec4cb75b63$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $cb3cd1ec4cb75b63$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cb3cd1ec4cb75b63$export$2e2bcd8739ae039 = $cb3cd1ec4cb75b63$var$formatLong;


var $da9fed17dc7a8697$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: 'P'
};
var $da9fed17dc7a8697$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: 'P'
};
var $da9fed17dc7a8697$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $da9fed17dc7a8697$var$formatRelativeLocalePlural[token];
    else return $da9fed17dc7a8697$var$formatRelativeLocale[token];
};
var $da9fed17dc7a8697$export$2e2bcd8739ae039 = $da9fed17dc7a8697$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $1153969890f3d902$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        "despu\xe9s de cristo"
    ]
};
var $1153969890f3d902$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $1153969890f3d902$var$monthValues = {
    narrow: [
        'e',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'ene',
        'feb',
        'mar',
        'abr',
        'may',
        'jun',
        'jul',
        'ago',
        'sep',
        'oct',
        'nov',
        'dic'
    ],
    wide: [
        'enero',
        'febrero',
        'marzo',
        'abril',
        'mayo',
        'junio',
        'julio',
        'agosto',
        'septiembre',
        'octubre',
        'noviembre',
        'diciembre'
    ]
};
var $1153969890f3d902$var$dayValues = {
    narrow: [
        'd',
        'l',
        'm',
        'm',
        'j',
        'v',
        's'
    ],
    short: [
        'do',
        'lu',
        'ma',
        'mi',
        'ju',
        'vi',
        "s\xe1"
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        "mi\xe9",
        'jue',
        'vie',
        "s\xe1b"
    ],
    wide: [
        'domingo',
        'lunes',
        'martes',
        "mi\xe9rcoles",
        'jueves',
        'viernes',
        "s\xe1bado"
    ]
};
var $1153969890f3d902$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "ma\xf1ana",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noche'
    }
};
var $1153969890f3d902$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'medianoche',
        noon: 'mediodia',
        morning: "de la ma\xf1ana",
        afternoon: 'de la tarde',
        evening: 'de la tarde',
        night: 'de la noche'
    }
};
var $1153969890f3d902$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $1153969890f3d902$var$localize = {
    ordinalNumber: $1153969890f3d902$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $1153969890f3d902$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $1153969890f3d902$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $1153969890f3d902$export$2e2bcd8739ae039 = $1153969890f3d902$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $823c4ca85d3538de$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $823c4ca85d3538de$var$parseOrdinalNumberPattern = /\d+/i;
var $823c4ca85d3538de$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $823c4ca85d3538de$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $823c4ca85d3538de$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $823c4ca85d3538de$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $823c4ca85d3538de$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $823c4ca85d3538de$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $823c4ca85d3538de$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $823c4ca85d3538de$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $823c4ca85d3538de$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $823c4ca85d3538de$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $823c4ca85d3538de$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $823c4ca85d3538de$var$matchOrdinalNumberPattern,
        parsePattern: $823c4ca85d3538de$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $823c4ca85d3538de$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $823c4ca85d3538de$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $823c4ca85d3538de$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $823c4ca85d3538de$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $823c4ca85d3538de$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $823c4ca85d3538de$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $823c4ca85d3538de$export$2e2bcd8739ae039 = $823c4ca85d3538de$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $c1cf831e41f9e145$var$locale = {
    code: 'es',
    formatDistance: (0, $77eafa43effd33b1$export$2e2bcd8739ae039),
    formatLong: (0, $cb3cd1ec4cb75b63$export$2e2bcd8739ae039),
    formatRelative: (0, $da9fed17dc7a8697$export$2e2bcd8739ae039),
    localize: (0, $1153969890f3d902$export$2e2bcd8739ae039),
    match: (0, $823c4ca85d3538de$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c1cf831e41f9e145$export$2e2bcd8739ae039 = $c1cf831e41f9e145$var$locale;
module.exports["default"] = $c1cf831e41f9e145$export$2e2bcd8739ae039;

});

parcelRegister("dqZrE", function(module, exports) {
function $9e2b01678f5bd460$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, 'sekunnin');
}
function $9e2b01678f5bd460$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, 'minuutin');
}
function $9e2b01678f5bd460$var$futureHours(text) {
    return text.replace(/tuntia?/, 'tunnin');
}
function $9e2b01678f5bd460$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $9e2b01678f5bd460$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, 'viikon');
}
function $9e2b01678f5bd460$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, 'kuukauden');
}
function $9e2b01678f5bd460$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, 'vuoden');
}
var $9e2b01678f5bd460$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'alle sekunti',
        other: 'alle {{count}} sekuntia',
        futureTense: $9e2b01678f5bd460$var$futureSeconds
    },
    xSeconds: {
        one: 'sekunti',
        other: '{{count}} sekuntia',
        futureTense: $9e2b01678f5bd460$var$futureSeconds
    },
    halfAMinute: {
        one: 'puoli minuuttia',
        other: 'puoli minuuttia',
        futureTense: function futureTense(_text) {
            return 'puolen minuutin';
        }
    },
    lessThanXMinutes: {
        one: 'alle minuutti',
        other: 'alle {{count}} minuuttia',
        futureTense: $9e2b01678f5bd460$var$futureMinutes
    },
    xMinutes: {
        one: 'minuutti',
        other: '{{count}} minuuttia',
        futureTense: $9e2b01678f5bd460$var$futureMinutes
    },
    aboutXHours: {
        one: 'noin tunti',
        other: 'noin {{count}} tuntia',
        futureTense: $9e2b01678f5bd460$var$futureHours
    },
    xHours: {
        one: 'tunti',
        other: '{{count}} tuntia',
        futureTense: $9e2b01678f5bd460$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $9e2b01678f5bd460$var$futureDays
    },
    aboutXWeeks: {
        one: 'noin viikko',
        other: 'noin {{count}} viikkoa',
        futureTense: $9e2b01678f5bd460$var$futureWeeks
    },
    xWeeks: {
        one: 'viikko',
        other: '{{count}} viikkoa',
        futureTense: $9e2b01678f5bd460$var$futureWeeks
    },
    aboutXMonths: {
        one: 'noin kuukausi',
        other: 'noin {{count}} kuukautta',
        futureTense: $9e2b01678f5bd460$var$futureMonths
    },
    xMonths: {
        one: 'kuukausi',
        other: '{{count}} kuukautta',
        futureTense: $9e2b01678f5bd460$var$futureMonths
    },
    aboutXYears: {
        one: 'noin vuosi',
        other: 'noin {{count}} vuotta',
        futureTense: $9e2b01678f5bd460$var$futureYears
    },
    xYears: {
        one: 'vuosi',
        other: '{{count}} vuotta',
        futureTense: $9e2b01678f5bd460$var$futureYears
    },
    overXYears: {
        one: 'yli vuosi',
        other: 'yli {{count}} vuotta',
        futureTense: $9e2b01678f5bd460$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $9e2b01678f5bd460$var$futureYears
    }
};
var $9e2b01678f5bd460$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $9e2b01678f5bd460$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + ' kuluttua';
        else return result + ' sitten';
    }
    return result;
};
var $9e2b01678f5bd460$export$2e2bcd8739ae039 = $9e2b01678f5bd460$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $7c8edf3bf1d14cfc$var$dateFormats = {
    full: 'eeee d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'd.M.y'
};
var $7c8edf3bf1d14cfc$var$timeFormats = {
    full: 'HH.mm.ss zzzz',
    long: 'HH.mm.ss z',
    medium: 'HH.mm.ss',
    short: 'HH.mm'
};
var $7c8edf3bf1d14cfc$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7c8edf3bf1d14cfc$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7c8edf3bf1d14cfc$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7c8edf3bf1d14cfc$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7c8edf3bf1d14cfc$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7c8edf3bf1d14cfc$export$2e2bcd8739ae039 = $7c8edf3bf1d14cfc$var$formatLong;


var $9c8ea36dc09a2f69$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: 'P'
};
var $9c8ea36dc09a2f69$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9c8ea36dc09a2f69$var$formatRelativeLocale[token];
};
var $9c8ea36dc09a2f69$export$2e2bcd8739ae039 = $9c8ea36dc09a2f69$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $7f752483d584f103$var$eraValues = {
    narrow: [
        'eaa.',
        'jaa.'
    ],
    abbreviated: [
        'eaa.',
        'jaa.'
    ],
    wide: [
        'ennen ajanlaskun alkua',
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $7f752483d584f103$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartaali',
        '2. kvartaali',
        '3. kvartaali',
        '4. kvartaali'
    ]
};
var $7f752483d584f103$var$monthValues = {
    narrow: [
        'T',
        'H',
        'M',
        'H',
        'T',
        'K',
        'H',
        'E',
        'S',
        'L',
        'M',
        'J'
    ],
    abbreviated: [
        'tammi',
        'helmi',
        'maalis',
        'huhti',
        'touko',
        "kes\xe4",
        "hein\xe4",
        'elo',
        'syys',
        'loka',
        'marras',
        'joulu'
    ],
    wide: [
        'tammikuu',
        'helmikuu',
        'maaliskuu',
        'huhtikuu',
        'toukokuu',
        "kes\xe4kuu",
        "hein\xe4kuu",
        'elokuu',
        'syyskuu',
        'lokakuu',
        'marraskuu',
        'joulukuu'
    ]
};
var $7f752483d584f103$var$formattingMonthValues = {
    narrow: $7f752483d584f103$var$monthValues.narrow,
    abbreviated: $7f752483d584f103$var$monthValues.abbreviated,
    wide: [
        'tammikuuta',
        'helmikuuta',
        'maaliskuuta',
        'huhtikuuta',
        'toukokuuta',
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        'elokuuta',
        'syyskuuta',
        'lokakuuta',
        'marraskuuta',
        'joulukuuta'
    ]
};
var $7f752483d584f103$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'K',
        'T',
        'P',
        'L'
    ],
    short: [
        'su',
        'ma',
        'ti',
        'ke',
        'to',
        'pe',
        'la'
    ],
    abbreviated: [
        'sunn.',
        'maan.',
        'tiis.',
        'kesk.',
        'torst.',
        'perj.',
        'la'
    ],
    wide: [
        'sunnuntai',
        'maanantai',
        'tiistai',
        'keskiviikko',
        'torstai',
        'perjantai',
        'lauantai'
    ]
};
var $7f752483d584f103$var$formattingDayValues = {
    narrow: $7f752483d584f103$var$dayValues.narrow,
    short: $7f752483d584f103$var$dayValues.short,
    abbreviated: $7f752483d584f103$var$dayValues.abbreviated,
    wide: [
        'sunnuntaina',
        'maanantaina',
        'tiistaina',
        'keskiviikkona',
        'torstaina',
        'perjantaina',
        'lauantaina'
    ]
};
var $7f752483d584f103$var$dayPeriodValues = {
    narrow: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: 'ap',
        afternoon: 'ip',
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: 'ap',
        pm: 'ip',
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: 'illalla',
        night: "y\xf6ll\xe4"
    }
};
var $7f752483d584f103$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $7f752483d584f103$var$localize = {
    ordinalNumber: $7f752483d584f103$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $7f752483d584f103$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $7f752483d584f103$var$formattingDayValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $7f752483d584f103$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $7f752483d584f103$export$2e2bcd8739ae039 = $7f752483d584f103$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $af6ea809f064e2be$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $af6ea809f064e2be$var$parseOrdinalNumberPattern = /\d+/i;
var $af6ea809f064e2be$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $af6ea809f064e2be$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $af6ea809f064e2be$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $af6ea809f064e2be$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $af6ea809f064e2be$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $af6ea809f064e2be$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $af6ea809f064e2be$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $af6ea809f064e2be$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $af6ea809f064e2be$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $af6ea809f064e2be$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $af6ea809f064e2be$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $af6ea809f064e2be$var$matchOrdinalNumberPattern,
        parsePattern: $af6ea809f064e2be$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6ea809f064e2be$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6ea809f064e2be$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6ea809f064e2be$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $af6ea809f064e2be$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $af6ea809f064e2be$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $af6ea809f064e2be$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $af6ea809f064e2be$export$2e2bcd8739ae039 = $af6ea809f064e2be$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $9c7d5dc265e3b511$var$locale = {
    code: 'fi',
    formatDistance: (0, $9e2b01678f5bd460$export$2e2bcd8739ae039),
    formatLong: (0, $7c8edf3bf1d14cfc$export$2e2bcd8739ae039),
    formatRelative: (0, $9c8ea36dc09a2f69$export$2e2bcd8739ae039),
    localize: (0, $7f752483d584f103$export$2e2bcd8739ae039),
    match: (0, $af6ea809f064e2be$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9c7d5dc265e3b511$export$2e2bcd8739ae039 = $9c7d5dc265e3b511$var$locale;
module.exports["default"] = $9c7d5dc265e3b511$export$2e2bcd8739ae039;

});

parcelRegister("k64l1", function(module, exports) {

var $9J4Kh = parcelRequire("9J4Kh");


var $fcGXP = parcelRequire("fcGXP");

var $7464303f880586b3$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $7464303f880586b3$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7464303f880586b3$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $7464303f880586b3$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7464303f880586b3$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7464303f880586b3$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7464303f880586b3$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7464303f880586b3$export$2e2bcd8739ae039 = $7464303f880586b3$var$formatLong;



var $drrJx = parcelRequire("drrJx");


var $97me1 = parcelRequire("97me1");


var $68FKa = parcelRequire("68FKa");

/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $ea17bb9df88bab0a$var$locale = {
    code: 'fr',
    formatDistance: (0, $9J4Kh.default),
    formatLong: (0, $7464303f880586b3$export$2e2bcd8739ae039),
    formatRelative: (0, $drrJx.default),
    localize: (0, $97me1.default),
    match: (0, $68FKa.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $ea17bb9df88bab0a$export$2e2bcd8739ae039 = $ea17bb9df88bab0a$var$locale;
module.exports["default"] = $ea17bb9df88bab0a$export$2e2bcd8739ae039;

});

parcelRegister("9J4Kh", function(module, exports) {
var $714bff5dee0f1eef$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: 'moins de {{count}} secondes'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} secondes'
    },
    halfAMinute: '30 secondes',
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: 'moins de {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'environ 1 heure',
        other: 'environ {{count}} heures'
    },
    xHours: {
        one: '1 heure',
        other: '{{count}} heures'
    },
    xDays: {
        one: '1 jour',
        other: '{{count}} jours'
    },
    aboutXWeeks: {
        one: 'environ 1 semaine',
        other: 'environ {{count}} semaines'
    },
    xWeeks: {
        one: '1 semaine',
        other: '{{count}} semaines'
    },
    aboutXMonths: {
        one: 'environ 1 mois',
        other: 'environ {{count}} mois'
    },
    xMonths: {
        one: '1 mois',
        other: '{{count}} mois'
    },
    aboutXYears: {
        one: 'environ 1 an',
        other: 'environ {{count}} ans'
    },
    xYears: {
        one: '1 an',
        other: '{{count}} ans'
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: 'plus de {{count}} ans'
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: 'presque {{count}} ans'
    }
};
var $714bff5dee0f1eef$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $714bff5dee0f1eef$var$formatDistanceLocale[token];
    if (typeof form === 'string') result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'dans ' + result;
        else return 'il y a ' + result;
    }
    return result;
};
var $714bff5dee0f1eef$export$2e2bcd8739ae039 = $714bff5dee0f1eef$var$formatDistance;
module.exports["default"] = $714bff5dee0f1eef$export$2e2bcd8739ae039;

});

parcelRegister("drrJx", function(module, exports) {
var $9c934f486536563a$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: 'P'
};
var $9c934f486536563a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9c934f486536563a$var$formatRelativeLocale[token];
};
var $9c934f486536563a$export$2e2bcd8739ae039 = $9c934f486536563a$var$formatRelative;
module.exports["default"] = $9c934f486536563a$export$2e2bcd8739ae039;

});

parcelRegister("97me1", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $6a3601f6e2effb3c$var$eraValues = {
    narrow: [
        'av. J.-C',
        'ap. J.-C'
    ],
    abbreviated: [
        'av. J.-C',
        'ap. J.-C'
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $6a3601f6e2effb3c$var$quarterValues = {
    narrow: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    abbreviated: [
        '1er trim.',
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        '1er trimestre',
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $6a3601f6e2effb3c$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'janv.',
        "f\xe9vr.",
        'mars',
        'avr.',
        'mai',
        'juin',
        'juil.',
        "ao\xfbt",
        'sept.',
        'oct.',
        'nov.',
        "d\xe9c."
    ],
    wide: [
        'janvier',
        "f\xe9vrier",
        'mars',
        'avril',
        'mai',
        'juin',
        'juillet',
        "ao\xfbt",
        'septembre',
        'octobre',
        'novembre',
        "d\xe9cembre"
    ]
};
var $6a3601f6e2effb3c$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'J',
        'V',
        'S'
    ],
    short: [
        'di',
        'lu',
        'ma',
        'me',
        'je',
        've',
        'sa'
    ],
    abbreviated: [
        'dim.',
        'lun.',
        'mar.',
        'mer.',
        'jeu.',
        'ven.',
        'sam.'
    ],
    wide: [
        'dimanche',
        'lundi',
        'mardi',
        'mercredi',
        'jeudi',
        'vendredi',
        'samedi'
    ]
};
var $6a3601f6e2effb3c$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'mat.',
        afternoon: 'ap.m.',
        evening: 'soir',
        night: 'mat.'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'matin',
        afternoon: "apr\xe8s-midi",
        evening: 'soir',
        night: 'matin'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'minuit',
        noon: 'midi',
        morning: 'du matin',
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: 'du soir',
        night: 'du matin'
    }
};
var $6a3601f6e2effb3c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return '0';
    var feminineUnits = [
        'year',
        'week',
        'hour',
        'minute',
        'second'
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : 'er';
    else suffix = "\xe8me";
    return number + suffix;
};
var $6a3601f6e2effb3c$var$localize = {
    ordinalNumber: $6a3601f6e2effb3c$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $6a3601f6e2effb3c$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $6a3601f6e2effb3c$export$2e2bcd8739ae039 = $6a3601f6e2effb3c$var$localize;
module.exports["default"] = $6a3601f6e2effb3c$export$2e2bcd8739ae039;

});

parcelRegister("68FKa", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $4783ded8b954ffe5$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $4783ded8b954ffe5$var$parseOrdinalNumberPattern = /\d+/i;
var $4783ded8b954ffe5$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $4783ded8b954ffe5$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $4783ded8b954ffe5$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $4783ded8b954ffe5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4783ded8b954ffe5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $4783ded8b954ffe5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $4783ded8b954ffe5$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $4783ded8b954ffe5$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $4783ded8b954ffe5$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $4783ded8b954ffe5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $4783ded8b954ffe5$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $4783ded8b954ffe5$var$matchOrdinalNumberPattern,
        parsePattern: $4783ded8b954ffe5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4783ded8b954ffe5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4783ded8b954ffe5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4783ded8b954ffe5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $4783ded8b954ffe5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $4783ded8b954ffe5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $4783ded8b954ffe5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $4783ded8b954ffe5$export$2e2bcd8739ae039 = $4783ded8b954ffe5$var$match;
module.exports["default"] = $4783ded8b954ffe5$export$2e2bcd8739ae039;

});

parcelRegister("5ykSD", function(module, exports) {
var $ddb4d4ec718cb1b7$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: 'majdnem',
    lessthan: 'kevesebb mint'
};
var $ddb4d4ec718cb1b7$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: ' perc',
    xhours: " \xf3ra",
    xdays: ' nap',
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $ddb4d4ec718cb1b7$var$withSuffixes = {
    xseconds: {
        '-1': " m\xe1sodperccel ezel\u0151tt",
        '1': " m\xe1sodperc m\xfalva",
        '0': " m\xe1sodperce"
    },
    halfaminute: {
        '-1': "f\xe9l perccel ezel\u0151tt",
        '1': "f\xe9l perc m\xfalva",
        '0': "f\xe9l perce"
    },
    xminutes: {
        '-1': " perccel ezel\u0151tt",
        '1': " perc m\xfalva",
        '0': ' perce'
    },
    xhours: {
        '-1': " \xf3r\xe1val ezel\u0151tt",
        '1': " \xf3ra m\xfalva",
        '0': " \xf3r\xe1ja"
    },
    xdays: {
        '-1': " nappal ezel\u0151tt",
        '1': " nap m\xfalva",
        '0': ' napja'
    },
    xweeks: {
        '-1': " h\xe9ttel ezel\u0151tt",
        '1': " h\xe9t m\xfalva",
        '0': ' hete'
    },
    xmonths: {
        '-1': " h\xf3nappal ezel\u0151tt",
        '1': " h\xf3nap m\xfalva",
        '0': " h\xf3napja"
    },
    xyears: {
        '-1': " \xe9vvel ezel\u0151tt",
        '1': " \xe9v m\xfalva",
        '0': " \xe9ve"
    }
};
var $ddb4d4ec718cb1b7$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], '') : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $ddb4d4ec718cb1b7$var$withSuffixes[key][comparison] : $ddb4d4ec718cb1b7$var$withoutSuffixes[key];
    var result = key === 'halfaminute' ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $ddb4d4ec718cb1b7$var$translations[adv] + ' ' + result;
    }
    return result;
};
var $ddb4d4ec718cb1b7$export$2e2bcd8739ae039 = $ddb4d4ec718cb1b7$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $fb6a003e9d8d1645$var$dateFormats = {
    full: 'y. MMMM d., EEEE',
    long: 'y. MMMM d.',
    medium: 'y. MMM d.',
    short: 'y. MM. dd.'
};
var $fb6a003e9d8d1645$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $fb6a003e9d8d1645$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $fb6a003e9d8d1645$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $fb6a003e9d8d1645$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $fb6a003e9d8d1645$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $fb6a003e9d8d1645$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $fb6a003e9d8d1645$export$2e2bcd8739ae039 = $fb6a003e9d8d1645$var$formatLong;


var $db65fbba084d31b5$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    'kedden',
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    'szombaton'
];
function $db65fbba084d31b5$var$week(isFuture) {
    return function(date) {
        var weekday = $db65fbba084d31b5$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? '' : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $db65fbba084d31b5$var$formatRelativeLocale = {
    lastWeek: $db65fbba084d31b5$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $db65fbba084d31b5$var$week(true),
    other: 'P'
};
var $db65fbba084d31b5$var$formatRelative = function formatRelative(token, date) {
    var format = $db65fbba084d31b5$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $db65fbba084d31b5$export$2e2bcd8739ae039 = $db65fbba084d31b5$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $301835724098a5d1$var$eraValues = {
    narrow: [
        'ie.',
        'isz.'
    ],
    abbreviated: [
        'i. e.',
        'i. sz.'
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $301835724098a5d1$var$quarterValues = {
    narrow: [
        '1.',
        '2.',
        '3.',
        '4.'
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $301835724098a5d1$var$formattingQuarterValues = {
    narrow: [
        'I.',
        'II.',
        'III.',
        'IV.'
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $301835724098a5d1$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        "\xc1",
        'M',
        'J',
        'J',
        'A',
        'Sz',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'febr.',
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        'aug.',
        'szept.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        'augusztus',
        'szeptember',
        "okt\xf3ber",
        'november',
        'december'
    ]
};
var $301835724098a5d1$var$dayValues = {
    narrow: [
        'V',
        'H',
        'K',
        'Sz',
        'Cs',
        'P',
        'Sz'
    ],
    short: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    abbreviated: [
        'V',
        'H',
        'K',
        'Sze',
        'Cs',
        'P',
        'Szo'
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        'kedd',
        'szerda',
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        'szombat'
    ]
};
var $301835724098a5d1$var$dayPeriodValues = {
    narrow: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    abbreviated: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: 'du.',
        evening: 'este',
        night: "\xe9jjel"
    },
    wide: {
        am: 'de.',
        pm: 'du.',
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: 'reggel',
        afternoon: "d\xe9lut\xe1n",
        evening: 'este',
        night: "\xe9jjel"
    }
};
var $301835724098a5d1$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $301835724098a5d1$var$localize = {
    ordinalNumber: $301835724098a5d1$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $301835724098a5d1$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide'
    }),
    month: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $301835724098a5d1$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $301835724098a5d1$export$2e2bcd8739ae039 = $301835724098a5d1$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $9d78e119f82ea9fa$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $9d78e119f82ea9fa$var$parseOrdinalNumberPattern = /\d+/i;
var $9d78e119f82ea9fa$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $9d78e119f82ea9fa$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $9d78e119f82ea9fa$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $9d78e119f82ea9fa$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $9d78e119f82ea9fa$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $9d78e119f82ea9fa$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $9d78e119f82ea9fa$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $9d78e119f82ea9fa$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $9d78e119f82ea9fa$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $9d78e119f82ea9fa$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $9d78e119f82ea9fa$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $9d78e119f82ea9fa$var$matchOrdinalNumberPattern,
        parsePattern: $9d78e119f82ea9fa$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9d78e119f82ea9fa$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9d78e119f82ea9fa$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9d78e119f82ea9fa$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $9d78e119f82ea9fa$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $9d78e119f82ea9fa$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $9d78e119f82ea9fa$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $9d78e119f82ea9fa$export$2e2bcd8739ae039 = $9d78e119f82ea9fa$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $40b05316fb9db818$var$locale = {
    code: 'hu',
    formatDistance: (0, $ddb4d4ec718cb1b7$export$2e2bcd8739ae039),
    formatLong: (0, $fb6a003e9d8d1645$export$2e2bcd8739ae039),
    formatRelative: (0, $db65fbba084d31b5$export$2e2bcd8739ae039),
    localize: (0, $301835724098a5d1$export$2e2bcd8739ae039),
    match: (0, $9d78e119f82ea9fa$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $40b05316fb9db818$export$2e2bcd8739ae039 = $40b05316fb9db818$var$locale;
module.exports["default"] = $40b05316fb9db818$export$2e2bcd8739ae039;

});

parcelRegister("9YZs4", function(module, exports) {

var $ellkl = parcelRequire("ellkl");


var $fcGXP = parcelRequire("fcGXP");

var $6fb2d15f95a41915$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/y'
};
var $6fb2d15f95a41915$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $6fb2d15f95a41915$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $6fb2d15f95a41915$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $6fb2d15f95a41915$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $6fb2d15f95a41915$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $6fb2d15f95a41915$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $6fb2d15f95a41915$export$2e2bcd8739ae039 = $6fb2d15f95a41915$var$formatLong;



var $geJmU = parcelRequire("geJmU");


var $c2vlP = parcelRequire("c2vlP");


var $bk6Tz = parcelRequire("bk6Tz");

/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $744962aa86c35b83$var$locale = {
    code: 'it',
    formatDistance: (0, $ellkl.default),
    formatLong: (0, $6fb2d15f95a41915$export$2e2bcd8739ae039),
    formatRelative: (0, $geJmU.default),
    localize: (0, $c2vlP.default),
    match: (0, $bk6Tz.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $744962aa86c35b83$export$2e2bcd8739ae039 = $744962aa86c35b83$var$locale;
module.exports["default"] = $744962aa86c35b83$export$2e2bcd8739ae039;

});

parcelRegister("ellkl", function(module, exports) {
var $a71391fb8b5ee549$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'meno di un secondo',
        other: 'meno di {{count}} secondi'
    },
    xSeconds: {
        one: 'un secondo',
        other: '{{count}} secondi'
    },
    halfAMinute: 'alcuni secondi',
    lessThanXMinutes: {
        one: 'meno di un minuto',
        other: 'meno di {{count}} minuti'
    },
    xMinutes: {
        one: 'un minuto',
        other: '{{count}} minuti'
    },
    aboutXHours: {
        one: "circa un'ora",
        other: 'circa {{count}} ore'
    },
    xHours: {
        one: "un'ora",
        other: '{{count}} ore'
    },
    xDays: {
        one: 'un giorno',
        other: '{{count}} giorni'
    },
    aboutXWeeks: {
        one: 'circa una settimana',
        other: 'circa {{count}} settimane'
    },
    xWeeks: {
        one: 'una settimana',
        other: '{{count}} settimane'
    },
    aboutXMonths: {
        one: 'circa un mese',
        other: 'circa {{count}} mesi'
    },
    xMonths: {
        one: 'un mese',
        other: '{{count}} mesi'
    },
    aboutXYears: {
        one: 'circa un anno',
        other: 'circa {{count}} anni'
    },
    xYears: {
        one: 'un anno',
        other: '{{count}} anni'
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: 'quasi un anno',
        other: 'quasi {{count}} anni'
    }
};
var $a71391fb8b5ee549$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a71391fb8b5ee549$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'tra ' + result;
        else return result + ' fa';
    }
    return result;
};
var $a71391fb8b5ee549$export$2e2bcd8739ae039 = $a71391fb8b5ee549$var$formatDistance;
module.exports["default"] = $a71391fb8b5ee549$export$2e2bcd8739ae039;

});

parcelRegister("geJmU", function(module, exports) {

var $gQ473 = parcelRequire("gQ473");

var $bd2125636e62d628$var$weekdays = [
    'domenica',
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    'sabato'
];
function $bd2125636e62d628$var$_lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $bd2125636e62d628$var$weekdays[day] + " scorso alle' p";
    }
}
function $bd2125636e62d628$var$thisWeek(day) {
    return "'" + $bd2125636e62d628$var$weekdays[day] + " alle' p";
}
function $bd2125636e62d628$var$_nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $bd2125636e62d628$var$weekdays[day] + " prossimo alle' p";
    }
}
var $bd2125636e62d628$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $bd2125636e62d628$var$thisWeek(day);
        else return $bd2125636e62d628$var$_lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $bd2125636e62d628$var$thisWeek(day);
        else return $bd2125636e62d628$var$_nextWeek(day);
    },
    other: 'P'
};
var $bd2125636e62d628$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $bd2125636e62d628$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $bd2125636e62d628$export$2e2bcd8739ae039 = $bd2125636e62d628$var$formatRelative;
module.exports["default"] = $bd2125636e62d628$export$2e2bcd8739ae039;

});

parcelRegister("c2vlP", function(module, exports) {

var $9v2ZC = parcelRequire("9v2ZC");

var $8c3dfd96bffc0100$var$eraValues = {
    narrow: [
        'aC',
        'dC'
    ],
    abbreviated: [
        'a.C.',
        'd.C.'
    ],
    wide: [
        'avanti Cristo',
        'dopo Cristo'
    ]
};
var $8c3dfd96bffc0100$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $8c3dfd96bffc0100$var$monthValues = {
    narrow: [
        'G',
        'F',
        'M',
        'A',
        'M',
        'G',
        'L',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'gen',
        'feb',
        'mar',
        'apr',
        'mag',
        'giu',
        'lug',
        'ago',
        'set',
        'ott',
        'nov',
        'dic'
    ],
    wide: [
        'gennaio',
        'febbraio',
        'marzo',
        'aprile',
        'maggio',
        'giugno',
        'luglio',
        'agosto',
        'settembre',
        'ottobre',
        'novembre',
        'dicembre'
    ]
};
var $8c3dfd96bffc0100$var$dayValues = {
    narrow: [
        'D',
        'L',
        'M',
        'M',
        'G',
        'V',
        'S'
    ],
    short: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    abbreviated: [
        'dom',
        'lun',
        'mar',
        'mer',
        'gio',
        'ven',
        'sab'
    ],
    wide: [
        'domenica',
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        'sabato'
    ]
};
var $8c3dfd96bffc0100$var$dayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'mattina',
        afternoon: 'pomeriggio',
        evening: 'sera',
        night: 'notte'
    }
};
var $8c3dfd96bffc0100$var$formattingDayPeriodValues = {
    narrow: {
        am: 'm.',
        pm: 'p.',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'mezzanotte',
        noon: 'mezzogiorno',
        morning: 'di mattina',
        afternoon: 'del pomeriggio',
        evening: 'di sera',
        night: 'di notte'
    }
};
var $8c3dfd96bffc0100$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var $8c3dfd96bffc0100$var$localize = {
    ordinalNumber: $8c3dfd96bffc0100$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $8c3dfd96bffc0100$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $8c3dfd96bffc0100$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $8c3dfd96bffc0100$export$2e2bcd8739ae039 = $8c3dfd96bffc0100$var$localize;
module.exports["default"] = $8c3dfd96bffc0100$export$2e2bcd8739ae039;

});

parcelRegister("bk6Tz", function(module, exports) {

var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $83e6e9388f063e32$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $83e6e9388f063e32$var$parseOrdinalNumberPattern = /\d+/i;
var $83e6e9388f063e32$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $83e6e9388f063e32$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $83e6e9388f063e32$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $83e6e9388f063e32$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $83e6e9388f063e32$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $83e6e9388f063e32$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $83e6e9388f063e32$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $83e6e9388f063e32$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $83e6e9388f063e32$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $83e6e9388f063e32$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $83e6e9388f063e32$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $83e6e9388f063e32$var$matchOrdinalNumberPattern,
        parsePattern: $83e6e9388f063e32$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83e6e9388f063e32$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83e6e9388f063e32$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83e6e9388f063e32$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $83e6e9388f063e32$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $83e6e9388f063e32$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $83e6e9388f063e32$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $83e6e9388f063e32$export$2e2bcd8739ae039 = $83e6e9388f063e32$var$match;
module.exports["default"] = $83e6e9388f063e32$export$2e2bcd8739ae039;

});

parcelRegister("lwYCg", function(module, exports) {
var $eb9246cedf948188$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var $eb9246cedf948188$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $eb9246cedf948188$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
var $eb9246cedf948188$export$2e2bcd8739ae039 = $eb9246cedf948188$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $f14e151245029cff$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: 'y/MM/dd',
    short: 'y/MM/dd'
};
var $f14e151245029cff$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $f14e151245029cff$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $f14e151245029cff$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $f14e151245029cff$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $f14e151245029cff$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $f14e151245029cff$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $f14e151245029cff$export$2e2bcd8739ae039 = $f14e151245029cff$var$formatLong;


var $5c2cb4cf5416a7bc$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: 'P'
};
var $5c2cb4cf5416a7bc$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5c2cb4cf5416a7bc$var$formatRelativeLocale[token];
};
var $5c2cb4cf5416a7bc$export$2e2bcd8739ae039 = $5c2cb4cf5416a7bc$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $287077c6645a281b$var$eraValues = {
    narrow: [
        'BC',
        'AC'
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var $287077c6645a281b$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var $287077c6645a281b$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var $287077c6645a281b$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var $287077c6645a281b$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $287077c6645a281b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $287077c6645a281b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'year':
            return "".concat(number, "\u5E74");
        case 'quarter':
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case 'month':
            return "".concat(number, "\u6708");
        case 'week':
            return "\u7B2C".concat(number, "\u9031");
        case 'date':
            return "".concat(number, "\u65E5");
        case 'hour':
            return "".concat(number, "\u6642");
        case 'minute':
            return "".concat(number, "\u5206");
        case 'second':
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var $287077c6645a281b$var$localize = {
    ordinalNumber: $287077c6645a281b$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $287077c6645a281b$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $287077c6645a281b$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $287077c6645a281b$export$2e2bcd8739ae039 = $287077c6645a281b$var$localize;



var $cIBX8 = parcelRequire("cIBX8");


var $cJpo8 = parcelRequire("cJpo8");

var $236ac3f89cc2eda2$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $236ac3f89cc2eda2$var$parseOrdinalNumberPattern = /\d+/i;
var $236ac3f89cc2eda2$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $236ac3f89cc2eda2$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $236ac3f89cc2eda2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $236ac3f89cc2eda2$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $236ac3f89cc2eda2$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $236ac3f89cc2eda2$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $236ac3f89cc2eda2$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $236ac3f89cc2eda2$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $236ac3f89cc2eda2$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $236ac3f89cc2eda2$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $236ac3f89cc2eda2$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $236ac3f89cc2eda2$var$matchOrdinalNumberPattern,
        parsePattern: $236ac3f89cc2eda2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $236ac3f89cc2eda2$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $236ac3f89cc2eda2$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $236ac3f89cc2eda2$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $236ac3f89cc2eda2$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $236ac3f89cc2eda2$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $236ac3f89cc2eda2$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $236ac3f89cc2eda2$export$2e2bcd8739ae039 = $236ac3f89cc2eda2$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $facb9b3e95506ec3$var$locale = {
    code: 'ja',
    formatDistance: (0, $eb9246cedf948188$export$2e2bcd8739ae039),
    formatLong: (0, $f14e151245029cff$export$2e2bcd8739ae039),
    formatRelative: (0, $5c2cb4cf5416a7bc$export$2e2bcd8739ae039),
    localize: (0, $287077c6645a281b$export$2e2bcd8739ae039),
    match: (0, $236ac3f89cc2eda2$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $facb9b3e95506ec3$export$2e2bcd8739ae039 = $facb9b3e95506ec3$var$locale;
module.exports["default"] = $facb9b3e95506ec3$export$2e2bcd8739ae039;

});

parcelRegister("458wa", function(module, exports) {
var $9a30edf95b41adab$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var $9a30edf95b41adab$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $9a30edf95b41adab$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
var $9a30edf95b41adab$export$2e2bcd8739ae039 = $9a30edf95b41adab$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $7846a3d80bd2c7a8$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: 'y.MM.dd',
    short: 'y.MM.dd'
};
var $7846a3d80bd2c7a8$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: 'a H:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $7846a3d80bd2c7a8$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $7846a3d80bd2c7a8$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $7846a3d80bd2c7a8$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $7846a3d80bd2c7a8$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $7846a3d80bd2c7a8$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $7846a3d80bd2c7a8$export$2e2bcd8739ae039 = $7846a3d80bd2c7a8$var$formatLong;


var $bf793897b825ffd5$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: 'P'
};
var $bf793897b825ffd5$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $bf793897b825ffd5$var$formatRelativeLocale[token];
};
var $bf793897b825ffd5$export$2e2bcd8739ae039 = $bf793897b825ffd5$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $e10f86f8e331e148$var$eraValues = {
    narrow: [
        'BC',
        'AD'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var $e10f86f8e331e148$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var $e10f86f8e331e148$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var $e10f86f8e331e148$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var $e10f86f8e331e148$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $e10f86f8e331e148$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $e10f86f8e331e148$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case 'minute':
        case 'second':
            return String(number);
        case 'date':
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var $e10f86f8e331e148$var$localize = {
    ordinalNumber: $e10f86f8e331e148$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e10f86f8e331e148$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e10f86f8e331e148$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e10f86f8e331e148$export$2e2bcd8739ae039 = $e10f86f8e331e148$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $1d9e38c2043347f4$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $1d9e38c2043347f4$var$parseOrdinalNumberPattern = /\d+/i;
var $1d9e38c2043347f4$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $1d9e38c2043347f4$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $1d9e38c2043347f4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $1d9e38c2043347f4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1d9e38c2043347f4$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $1d9e38c2043347f4$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $1d9e38c2043347f4$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $1d9e38c2043347f4$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $1d9e38c2043347f4$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $1d9e38c2043347f4$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $1d9e38c2043347f4$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $1d9e38c2043347f4$var$matchOrdinalNumberPattern,
        parsePattern: $1d9e38c2043347f4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1d9e38c2043347f4$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1d9e38c2043347f4$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1d9e38c2043347f4$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $1d9e38c2043347f4$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $1d9e38c2043347f4$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $1d9e38c2043347f4$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $1d9e38c2043347f4$export$2e2bcd8739ae039 = $1d9e38c2043347f4$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $2f8e3c8391fc083c$var$locale = {
    code: 'ko',
    formatDistance: (0, $9a30edf95b41adab$export$2e2bcd8739ae039),
    formatLong: (0, $7846a3d80bd2c7a8$export$2e2bcd8739ae039),
    formatRelative: (0, $bf793897b825ffd5$export$2e2bcd8739ae039),
    localize: (0, $e10f86f8e331e148$export$2e2bcd8739ae039),
    match: (0, $1d9e38c2043347f4$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2f8e3c8391fc083c$export$2e2bcd8739ae039 = $2f8e3c8391fc083c$var$locale;
module.exports["default"] = $2f8e3c8391fc083c$export$2e2bcd8739ae039;

});

parcelRegister("3y6aU", function(module, exports) {
var $a2118b34269ad3cd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'mindre enn ett sekund',
        other: 'mindre enn {{count}} sekunder'
    },
    xSeconds: {
        one: 'ett sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'et halvt minutt',
    lessThanXMinutes: {
        one: 'mindre enn ett minutt',
        other: 'mindre enn {{count}} minutter'
    },
    xMinutes: {
        one: 'ett minutt',
        other: '{{count}} minutter'
    },
    aboutXHours: {
        one: 'omtrent en time',
        other: 'omtrent {{count}} timer'
    },
    xHours: {
        one: 'en time',
        other: '{{count}} timer'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dager'
    },
    aboutXWeeks: {
        one: 'omtrent en uke',
        other: 'omtrent {{count}} uker'
    },
    xWeeks: {
        one: 'en uke',
        other: '{{count}} uker'
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $a2118b34269ad3cd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $a2118b34269ad3cd$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' siden';
    }
    return result;
};
var $a2118b34269ad3cd$export$2e2bcd8739ae039 = $a2118b34269ad3cd$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $02337f3258030beb$var$dateFormats = {
    full: 'EEEE d. MMMM y',
    long: 'd. MMMM y',
    medium: 'd. MMM y',
    short: 'dd.MM.y'
};
var $02337f3258030beb$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $02337f3258030beb$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $02337f3258030beb$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $02337f3258030beb$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $02337f3258030beb$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $02337f3258030beb$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $02337f3258030beb$export$2e2bcd8739ae039 = $02337f3258030beb$var$formatLong;


var $799feb331933489d$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $799feb331933489d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $799feb331933489d$var$formatRelativeLocale[token];
};
var $799feb331933489d$export$2e2bcd8739ae039 = $799feb331933489d$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $a447d2e853ed6e50$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf8r Kristus",
        'etter Kristus'
    ]
};
var $a447d2e853ed6e50$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1. kvartal',
        '2. kvartal',
        '3. kvartal',
        '4. kvartal'
    ]
};
var $a447d2e853ed6e50$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'mai',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'des.'
    ],
    wide: [
        'januar',
        'februar',
        'mars',
        'april',
        'mai',
        'juni',
        'juli',
        'august',
        'september',
        'oktober',
        'november',
        'desember'
    ]
};
var $a447d2e853ed6e50$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf8",
        'ma',
        'ti',
        'on',
        'to',
        'fr',
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        'man',
        'tir',
        'ons',
        'tor',
        'fre',
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        'mandag',
        'tirsdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf8rdag"
    ]
};
var $a447d2e853ed6e50$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $a447d2e853ed6e50$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $a447d2e853ed6e50$var$localize = {
    ordinalNumber: $a447d2e853ed6e50$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a447d2e853ed6e50$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $a447d2e853ed6e50$export$2e2bcd8739ae039 = $a447d2e853ed6e50$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $798ede10b5682819$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $798ede10b5682819$var$parseOrdinalNumberPattern = /\d+/i;
var $798ede10b5682819$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $798ede10b5682819$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $798ede10b5682819$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $798ede10b5682819$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $798ede10b5682819$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $798ede10b5682819$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $798ede10b5682819$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $798ede10b5682819$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $798ede10b5682819$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $798ede10b5682819$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $798ede10b5682819$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $798ede10b5682819$var$matchOrdinalNumberPattern,
        parsePattern: $798ede10b5682819$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $798ede10b5682819$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $798ede10b5682819$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $798ede10b5682819$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $798ede10b5682819$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $798ede10b5682819$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $798ede10b5682819$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $798ede10b5682819$export$2e2bcd8739ae039 = $798ede10b5682819$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $2959564810867a6e$var$locale = {
    code: 'nb',
    formatDistance: (0, $a2118b34269ad3cd$export$2e2bcd8739ae039),
    formatLong: (0, $02337f3258030beb$export$2e2bcd8739ae039),
    formatRelative: (0, $799feb331933489d$export$2e2bcd8739ae039),
    localize: (0, $a447d2e853ed6e50$export$2e2bcd8739ae039),
    match: (0, $798ede10b5682819$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2959564810867a6e$export$2e2bcd8739ae039 = $2959564810867a6e$var$locale;
module.exports["default"] = $2959564810867a6e$export$2e2bcd8739ae039;

});

parcelRegister("i6MM7", function(module, exports) {
var $d2416eb4c291058a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'minder dan een seconde',
        other: 'minder dan {{count}} seconden'
    },
    xSeconds: {
        one: '1 seconde',
        other: '{{count}} seconden'
    },
    halfAMinute: 'een halve minuut',
    lessThanXMinutes: {
        one: 'minder dan een minuut',
        other: 'minder dan {{count}} minuten'
    },
    xMinutes: {
        one: 'een minuut',
        other: '{{count}} minuten'
    },
    aboutXHours: {
        one: 'ongeveer 1 uur',
        other: 'ongeveer {{count}} uur'
    },
    xHours: {
        one: '1 uur',
        other: '{{count}} uur'
    },
    xDays: {
        one: '1 dag',
        other: '{{count}} dagen'
    },
    aboutXWeeks: {
        one: 'ongeveer 1 week',
        other: 'ongeveer {{count}} weken'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weken'
    },
    aboutXMonths: {
        one: 'ongeveer 1 maand',
        other: 'ongeveer {{count}} maanden'
    },
    xMonths: {
        one: '1 maand',
        other: '{{count}} maanden'
    },
    aboutXYears: {
        one: 'ongeveer 1 jaar',
        other: 'ongeveer {{count}} jaar'
    },
    xYears: {
        one: '1 jaar',
        other: '{{count}} jaar'
    },
    overXYears: {
        one: 'meer dan 1 jaar',
        other: 'meer dan {{count}} jaar'
    },
    almostXYears: {
        one: 'bijna 1 jaar',
        other: 'bijna {{count}} jaar'
    }
};
var $d2416eb4c291058a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d2416eb4c291058a$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'over ' + result;
        else return result + ' geleden';
    }
    return result;
};
var $d2416eb4c291058a$export$2e2bcd8739ae039 = $d2416eb4c291058a$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $28eaeb3bab3ca544$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd-MM-y'
};
var $28eaeb3bab3ca544$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $28eaeb3bab3ca544$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $28eaeb3bab3ca544$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $28eaeb3bab3ca544$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $28eaeb3bab3ca544$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $28eaeb3bab3ca544$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $28eaeb3bab3ca544$export$2e2bcd8739ae039 = $28eaeb3bab3ca544$var$formatLong;


var $6ca671d192e5b220$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: 'P'
};
var $6ca671d192e5b220$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6ca671d192e5b220$var$formatRelativeLocale[token];
};
var $6ca671d192e5b220$export$2e2bcd8739ae039 = $6ca671d192e5b220$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $9a5a222f29e9d1e3$var$eraValues = {
    narrow: [
        'v.C.',
        'n.C.'
    ],
    abbreviated: [
        'v.Chr.',
        'n.Chr.'
    ],
    wide: [
        'voor Christus',
        'na Christus'
    ]
};
var $9a5a222f29e9d1e3$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'K1',
        'K2',
        'K3',
        'K4'
    ],
    wide: [
        '1e kwartaal',
        '2e kwartaal',
        '3e kwartaal',
        '4e kwartaal'
    ]
};
var $9a5a222f29e9d1e3$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mrt.',
        'apr.',
        'mei',
        'jun.',
        'jul.',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'maart',
        'april',
        'mei',
        'juni',
        'juli',
        'augustus',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $9a5a222f29e9d1e3$var$dayValues = {
    narrow: [
        'Z',
        'M',
        'D',
        'W',
        'D',
        'V',
        'Z'
    ],
    short: [
        'zo',
        'ma',
        'di',
        'wo',
        'do',
        'vr',
        'za'
    ],
    abbreviated: [
        'zon',
        'maa',
        'din',
        'woe',
        'don',
        'vri',
        'zat'
    ],
    wide: [
        'zondag',
        'maandag',
        'dinsdag',
        'woensdag',
        'donderdag',
        'vrijdag',
        'zaterdag'
    ]
};
var $9a5a222f29e9d1e3$var$dayPeriodValues = {
    narrow: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: 'middernacht',
        noon: 'het middaguur',
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $9a5a222f29e9d1e3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + 'e';
};
var $9a5a222f29e9d1e3$var$localize = {
    ordinalNumber: $9a5a222f29e9d1e3$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $9a5a222f29e9d1e3$var$dayPeriodValues,
        defaultWidth: 'wide'
    })
};
var $9a5a222f29e9d1e3$export$2e2bcd8739ae039 = $9a5a222f29e9d1e3$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $2ca87932c12940c4$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $2ca87932c12940c4$var$parseOrdinalNumberPattern = /\d+/i;
var $2ca87932c12940c4$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $2ca87932c12940c4$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $2ca87932c12940c4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $2ca87932c12940c4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2ca87932c12940c4$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $2ca87932c12940c4$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $2ca87932c12940c4$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $2ca87932c12940c4$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $2ca87932c12940c4$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $2ca87932c12940c4$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $2ca87932c12940c4$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $2ca87932c12940c4$var$matchOrdinalNumberPattern,
        parsePattern: $2ca87932c12940c4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ca87932c12940c4$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ca87932c12940c4$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ca87932c12940c4$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $2ca87932c12940c4$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $2ca87932c12940c4$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $2ca87932c12940c4$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $2ca87932c12940c4$export$2e2bcd8739ae039 = $2ca87932c12940c4$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $d2ee9f3efedaf64f$var$locale = {
    code: 'nl',
    formatDistance: (0, $d2416eb4c291058a$export$2e2bcd8739ae039),
    formatLong: (0, $28eaeb3bab3ca544$export$2e2bcd8739ae039),
    formatRelative: (0, $6ca671d192e5b220$export$2e2bcd8739ae039),
    localize: (0, $9a5a222f29e9d1e3$export$2e2bcd8739ae039),
    match: (0, $2ca87932c12940c4$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d2ee9f3efedaf64f$export$2e2bcd8739ae039 = $d2ee9f3efedaf64f$var$locale;
module.exports["default"] = $d2ee9f3efedaf64f$export$2e2bcd8739ae039;

});

parcelRegister("353ym", function(module, exports) {
var $dd90723ec95793c1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: 'sekunda',
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: '{{count}} sekundy',
        other: '{{count}} sekund'
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: 'minuta',
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: '{{count}} minuty',
        other: '{{count}} minut'
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: 'godzina',
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: '{{count}} godziny',
        other: '{{count}} godzin'
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: '{{count}} dni',
        other: '{{count}} dni'
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: '{{count}} tygodnie',
        other: '{{count}} tygodni'
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: 'rok',
        twoFour: '{{count}} lata',
        other: '{{count}} lat'
    },
    overXYears: {
        one: 'ponad rok',
        twoFour: 'ponad {{count}} lata',
        other: 'ponad {{count}} lat'
    },
    almostXYears: {
        one: 'prawie rok',
        twoFour: 'prawie {{count}} lata',
        other: 'prawie {{count}} lat'
    }
};
function $dd90723ec95793c1$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $dd90723ec95793c1$var$declension(scheme, count, time) {
    var group = $dd90723ec95793c1$var$declensionGroup(scheme, count);
    var finalText = typeof group === 'string' ? group : group[time];
    return finalText.replace('{{count}}', String(count));
}
var $dd90723ec95793c1$var$formatDistance = function formatDistance(token, count, options) {
    var scheme = $dd90723ec95793c1$var$formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $dd90723ec95793c1$var$declension(scheme, count, 'regular');
    if (options.comparison && options.comparison > 0) return 'za ' + $dd90723ec95793c1$var$declension(scheme, count, 'future');
    else return $dd90723ec95793c1$var$declension(scheme, count, 'past') + ' temu';
};
var $dd90723ec95793c1$export$2e2bcd8739ae039 = $dd90723ec95793c1$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $76c2927b2dbd3bc1$var$dateFormats = {
    full: 'EEEE, do MMMM y',
    long: 'do MMMM y',
    medium: 'do MMM y',
    short: 'dd.MM.y'
};
var $76c2927b2dbd3bc1$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $76c2927b2dbd3bc1$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $76c2927b2dbd3bc1$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $76c2927b2dbd3bc1$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $76c2927b2dbd3bc1$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $76c2927b2dbd3bc1$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $76c2927b2dbd3bc1$export$2e2bcd8739ae039 = $76c2927b2dbd3bc1$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

var $dabe8d3352fb27f5$var$adjectivesLastWeek = {
    masculine: 'ostatni',
    feminine: 'ostatnia'
};
var $dabe8d3352fb27f5$var$adjectivesThisWeek = {
    masculine: 'ten',
    feminine: 'ta'
};
var $dabe8d3352fb27f5$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var $dabe8d3352fb27f5$var$dayGrammaticalGender = {
    0: 'feminine',
    1: 'masculine',
    2: 'masculine',
    3: 'feminine',
    4: 'masculine',
    5: 'masculine',
    6: 'feminine'
};
function $dabe8d3352fb27f5$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, $gQ473.default)(date, baseDate, options)) adjectives = $dabe8d3352fb27f5$var$adjectivesThisWeek;
    else if (token === 'lastWeek') adjectives = $dabe8d3352fb27f5$var$adjectivesLastWeek;
    else if (token === 'nextWeek') adjectives = $dabe8d3352fb27f5$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = $dabe8d3352fb27f5$var$dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var $dabe8d3352fb27f5$var$formatRelativeLocale = {
    lastWeek: $dabe8d3352fb27f5$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $dabe8d3352fb27f5$var$dayAndTimeWithAdjective,
    other: 'P'
};
var $dabe8d3352fb27f5$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $dabe8d3352fb27f5$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(token, date, baseDate, options);
    return format;
};
var $dabe8d3352fb27f5$export$2e2bcd8739ae039 = $dabe8d3352fb27f5$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $160be87489e0c135$var$eraValues = {
    narrow: [
        'p.n.e.',
        'n.e.'
    ],
    abbreviated: [
        'p.n.e.',
        'n.e.'
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        'naszej ery'
    ]
};
var $160be87489e0c135$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'I kw.',
        'II kw.',
        'III kw.',
        'IV kw.'
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var $160be87489e0c135$var$monthValues = {
    narrow: [
        'S',
        'L',
        'M',
        'K',
        'M',
        'C',
        'L',
        'S',
        'W',
        'P',
        'L',
        'G'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        "stycze\u0144",
        'luty',
        'marzec',
        "kwiecie\u0144",
        'maj',
        'czerwiec',
        'lipiec',
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        'listopad',
        "grudzie\u0144"
    ]
};
var $160be87489e0c135$var$monthFormattingValues = {
    narrow: [
        's',
        'l',
        'm',
        'k',
        'm',
        'c',
        'l',
        's',
        'w',
        'p',
        'l',
        'g'
    ],
    abbreviated: [
        'sty',
        'lut',
        'mar',
        'kwi',
        'maj',
        'cze',
        'lip',
        'sie',
        'wrz',
        "pa\u017A",
        'lis',
        'gru'
    ],
    wide: [
        'stycznia',
        'lutego',
        'marca',
        'kwietnia',
        'maja',
        'czerwca',
        'lipca',
        'sierpnia',
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        'listopada',
        'grudnia'
    ]
};
var $160be87489e0c135$var$dayValues = {
    narrow: [
        'N',
        'P',
        'W',
        "\u015A",
        'C',
        'P',
        'S'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $160be87489e0c135$var$dayFormattingValues = {
    narrow: [
        'n',
        'p',
        'w',
        "\u015B",
        'c',
        'p',
        's'
    ],
    short: [
        'nie',
        'pon',
        'wto',
        "\u015Bro",
        'czw',
        "pi\u0105",
        'sob'
    ],
    abbreviated: [
        'niedz.',
        'pon.',
        'wt.',
        "\u015Br.",
        'czw.',
        'pt.',
        'sob.'
    ],
    wide: [
        'niedziela',
        "poniedzia\u0142ek",
        'wtorek',
        "\u015Broda",
        'czwartek',
        "pi\u0105tek",
        'sobota'
    ]
};
var $160be87489e0c135$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: 'rano',
        afternoon: "popo\u0142.",
        evening: 'wiecz.',
        night: 'noc'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: 'rano',
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: 'noc'
    }
};
var $160be87489e0c135$var$dayPeriodFormattingValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: 'rano',
        afternoon: "po po\u0142.",
        evening: 'wiecz.',
        night: 'w nocy'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    },
    wide: {
        am: 'AM',
        pm: 'PM',
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: 'rano',
        afternoon: "po po\u0142udniu",
        evening: 'wieczorem',
        night: 'w nocy'
    }
};
var $160be87489e0c135$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $160be87489e0c135$var$localize = {
    ordinalNumber: $160be87489e0c135$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $160be87489e0c135$var$monthFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$dayValues,
        defaultWidth: 'wide',
        formattingValues: $160be87489e0c135$var$dayFormattingValues,
        defaultFormattingWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $160be87489e0c135$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $160be87489e0c135$var$dayPeriodFormattingValues,
        defaultFormattingWidth: 'wide'
    })
};
var $160be87489e0c135$export$2e2bcd8739ae039 = $160be87489e0c135$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $8775a5ad7036f19b$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $8775a5ad7036f19b$var$parseOrdinalNumberPattern = /\d+/i;
var $8775a5ad7036f19b$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $8775a5ad7036f19b$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $8775a5ad7036f19b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $8775a5ad7036f19b$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $8775a5ad7036f19b$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $8775a5ad7036f19b$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $8775a5ad7036f19b$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $8775a5ad7036f19b$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $8775a5ad7036f19b$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $8775a5ad7036f19b$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $8775a5ad7036f19b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $8775a5ad7036f19b$var$matchOrdinalNumberPattern,
        parsePattern: $8775a5ad7036f19b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8775a5ad7036f19b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8775a5ad7036f19b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8775a5ad7036f19b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $8775a5ad7036f19b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $8775a5ad7036f19b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $8775a5ad7036f19b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $8775a5ad7036f19b$export$2e2bcd8739ae039 = $8775a5ad7036f19b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $23e4984b81369ddb$var$locale = {
    code: 'pl',
    formatDistance: (0, $dd90723ec95793c1$export$2e2bcd8739ae039),
    formatLong: (0, $76c2927b2dbd3bc1$export$2e2bcd8739ae039),
    formatRelative: (0, $dabe8d3352fb27f5$export$2e2bcd8739ae039),
    localize: (0, $160be87489e0c135$export$2e2bcd8739ae039),
    match: (0, $8775a5ad7036f19b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $23e4984b81369ddb$export$2e2bcd8739ae039 = $23e4984b81369ddb$var$locale;
module.exports["default"] = $23e4984b81369ddb$export$2e2bcd8739ae039;

});

parcelRegister("lBaG3", function(module, exports) {
var $f89d996e2905c311$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'menos de um segundo',
        other: 'menos de {{count}} segundos'
    },
    xSeconds: {
        one: '1 segundo',
        other: '{{count}} segundos'
    },
    halfAMinute: 'meio minuto',
    lessThanXMinutes: {
        one: 'menos de um minuto',
        other: 'menos de {{count}} minutos'
    },
    xMinutes: {
        one: '1 minuto',
        other: '{{count}} minutos'
    },
    aboutXHours: {
        one: 'cerca de 1 hora',
        other: 'cerca de {{count}} horas'
    },
    xHours: {
        one: '1 hora',
        other: '{{count}} horas'
    },
    xDays: {
        one: '1 dia',
        other: '{{count}} dias'
    },
    aboutXWeeks: {
        one: 'cerca de 1 semana',
        other: 'cerca de {{count}} semanas'
    },
    xWeeks: {
        one: '1 semana',
        other: '{{count}} semanas'
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: 'cerca de {{count}} meses'
    },
    xMonths: {
        one: "1 m\xeas",
        other: '{{count}} meses'
    },
    aboutXYears: {
        one: 'cerca de 1 ano',
        other: 'cerca de {{count}} anos'
    },
    xYears: {
        one: '1 ano',
        other: '{{count}} anos'
    },
    overXYears: {
        one: 'mais de 1 ano',
        other: 'mais de {{count}} anos'
    },
    almostXYears: {
        one: 'quase 1 ano',
        other: 'quase {{count}} anos'
    }
};
var $f89d996e2905c311$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f89d996e2905c311$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'em ' + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $f89d996e2905c311$export$2e2bcd8739ae039 = $f89d996e2905c311$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $cbb04f4531a0bc08$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $cbb04f4531a0bc08$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $cbb04f4531a0bc08$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $cbb04f4531a0bc08$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $cbb04f4531a0bc08$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $cbb04f4531a0bc08$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $cbb04f4531a0bc08$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $cbb04f4531a0bc08$export$2e2bcd8739ae039 = $cbb04f4531a0bc08$var$formatLong;


var $85c871ae3499d42c$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: 'P'
};
var $85c871ae3499d42c$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $85c871ae3499d42c$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date);
    return format;
};
var $85c871ae3499d42c$export$2e2bcd8739ae039 = $85c871ae3499d42c$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $cd8fd7aad48dd8b6$var$eraValues = {
    narrow: [
        'AC',
        'DC'
    ],
    abbreviated: [
        'AC',
        'DC'
    ],
    wide: [
        'antes de cristo',
        'depois de cristo'
    ]
};
var $cd8fd7aad48dd8b6$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'T1',
        'T2',
        'T3',
        'T4'
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $cd8fd7aad48dd8b6$var$monthValues = {
    narrow: [
        'j',
        'f',
        'm',
        'a',
        'm',
        'j',
        'j',
        'a',
        's',
        'o',
        'n',
        'd'
    ],
    abbreviated: [
        'jan',
        'fev',
        'mar',
        'abr',
        'mai',
        'jun',
        'jul',
        'ago',
        'set',
        'out',
        'nov',
        'dez'
    ],
    wide: [
        'janeiro',
        'fevereiro',
        "mar\xe7o",
        'abril',
        'maio',
        'junho',
        'julho',
        'agosto',
        'setembro',
        'outubro',
        'novembro',
        'dezembro'
    ]
};
var $cd8fd7aad48dd8b6$var$dayValues = {
    narrow: [
        'D',
        'S',
        'T',
        'Q',
        'Q',
        'S',
        'S'
    ],
    short: [
        'dom',
        'seg',
        'ter',
        'qua',
        'qui',
        'sex',
        'sab'
    ],
    abbreviated: [
        'domingo',
        'segunda',
        "ter\xe7a",
        'quarta',
        'quinta',
        'sexta',
        "s\xe1bado"
    ],
    wide: [
        'domingo',
        'segunda-feira',
        "ter\xe7a-feira",
        'quarta-feira',
        'quinta-feira',
        'sexta-feira',
        "s\xe1bado"
    ]
};
var $cd8fd7aad48dd8b6$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "manh\xe3",
        afternoon: 'tarde',
        evening: 'tarde',
        night: 'noite'
    }
};
var $cd8fd7aad48dd8b6$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mn',
        noon: 'md',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'meia-noite',
        noon: 'meio-dia',
        morning: "da manh\xe3",
        afternoon: 'da tarde',
        evening: 'da tarde',
        night: 'da noite'
    }
};
var $cd8fd7aad48dd8b6$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') return number + "\xaa";
    return number + "\xba";
};
var $cd8fd7aad48dd8b6$var$localize = {
    ordinalNumber: $cd8fd7aad48dd8b6$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $cd8fd7aad48dd8b6$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $cd8fd7aad48dd8b6$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $cd8fd7aad48dd8b6$export$2e2bcd8739ae039 = $cd8fd7aad48dd8b6$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $cf9e9b8f54ac2e9b$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $cf9e9b8f54ac2e9b$var$parseOrdinalNumberPattern = /\d+/i;
var $cf9e9b8f54ac2e9b$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $cf9e9b8f54ac2e9b$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $cf9e9b8f54ac2e9b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $cf9e9b8f54ac2e9b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $cf9e9b8f54ac2e9b$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $cf9e9b8f54ac2e9b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $cf9e9b8f54ac2e9b$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $cf9e9b8f54ac2e9b$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $cf9e9b8f54ac2e9b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $cf9e9b8f54ac2e9b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $cf9e9b8f54ac2e9b$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $cf9e9b8f54ac2e9b$var$matchOrdinalNumberPattern,
        parsePattern: $cf9e9b8f54ac2e9b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $cf9e9b8f54ac2e9b$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $cf9e9b8f54ac2e9b$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $cf9e9b8f54ac2e9b$export$2e2bcd8739ae039 = $cf9e9b8f54ac2e9b$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $fb9555fb784915b0$var$locale = {
    code: 'pt-BR',
    formatDistance: (0, $f89d996e2905c311$export$2e2bcd8739ae039),
    formatLong: (0, $cbb04f4531a0bc08$export$2e2bcd8739ae039),
    formatRelative: (0, $85c871ae3499d42c$export$2e2bcd8739ae039),
    localize: (0, $cd8fd7aad48dd8b6$export$2e2bcd8739ae039),
    match: (0, $cf9e9b8f54ac2e9b$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $fb9555fb784915b0$export$2e2bcd8739ae039 = $fb9555fb784915b0$var$locale;
module.exports["default"] = $fb9555fb784915b0$export$2e2bcd8739ae039;

});

parcelRegister("gYfFg", function(module, exports) {
function $9ddb1e7b3e4b0f55$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $9ddb1e7b3e4b0f55$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $9ddb1e7b3e4b0f55$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $9ddb1e7b3e4b0f55$var$declension(scheme.past, count);
                else return $9ddb1e7b3e4b0f55$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $9ddb1e7b3e4b0f55$var$declension(scheme.regular, count);
    };
}
var $9ddb1e7b3e4b0f55$var$formatDistanceLocale = {
    lessThanXSeconds: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $9ddb1e7b3e4b0f55$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var $9ddb1e7b3e4b0f55$var$formatDistance = function formatDistance(token, count, options) {
    return $9ddb1e7b3e4b0f55$var$formatDistanceLocale[token](count, options);
};
var $9ddb1e7b3e4b0f55$export$2e2bcd8739ae039 = $9ddb1e7b3e4b0f55$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $e3b8e8667b5854d5$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: 'dd.MM.y'
};
var $e3b8e8667b5854d5$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $e3b8e8667b5854d5$var$dateTimeFormats = {
    any: '{{date}}, {{time}}'
};
var $e3b8e8667b5854d5$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $e3b8e8667b5854d5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $e3b8e8667b5854d5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $e3b8e8667b5854d5$var$dateTimeFormats,
        defaultWidth: 'any'
    })
};
var $e3b8e8667b5854d5$export$2e2bcd8739ae039 = $e3b8e8667b5854d5$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

var $bab93de8dcdee896$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $bab93de8dcdee896$var$_lastWeek(day) {
    var weekday = $bab93de8dcdee896$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $bab93de8dcdee896$var$thisWeek(day) {
    var weekday = $bab93de8dcdee896$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $bab93de8dcdee896$var$_nextWeek(day) {
    var weekday = $bab93de8dcdee896$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var $bab93de8dcdee896$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $bab93de8dcdee896$var$thisWeek(day);
        else return $bab93de8dcdee896$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $gQ473.default)(date, baseDate, options)) return $bab93de8dcdee896$var$thisWeek(day);
        else return $bab93de8dcdee896$var$_nextWeek(day);
    },
    other: 'P'
};
var $bab93de8dcdee896$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $bab93de8dcdee896$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $bab93de8dcdee896$export$2e2bcd8739ae039 = $bab93de8dcdee896$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $74008c60c6ad6ba7$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var $74008c60c6ad6ba7$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $74008c60c6ad6ba7$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var $74008c60c6ad6ba7$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var $74008c60c6ad6ba7$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var $74008c60c6ad6ba7$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var $74008c60c6ad6ba7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var $74008c60c6ad6ba7$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === 'date') suffix = "-\u0435";
    else if (unit === 'week' || unit === 'minute' || unit === 'second') suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var $74008c60c6ad6ba7$var$localize = {
    ordinalNumber: $74008c60c6ad6ba7$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $74008c60c6ad6ba7$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $74008c60c6ad6ba7$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $74008c60c6ad6ba7$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $74008c60c6ad6ba7$export$2e2bcd8739ae039 = $74008c60c6ad6ba7$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $d24fc856082463b5$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $d24fc856082463b5$var$parseOrdinalNumberPattern = /\d+/i;
var $d24fc856082463b5$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $d24fc856082463b5$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $d24fc856082463b5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $d24fc856082463b5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d24fc856082463b5$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $d24fc856082463b5$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $d24fc856082463b5$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $d24fc856082463b5$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $d24fc856082463b5$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $d24fc856082463b5$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $d24fc856082463b5$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $d24fc856082463b5$var$matchOrdinalNumberPattern,
        parsePattern: $d24fc856082463b5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $d24fc856082463b5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $d24fc856082463b5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $d24fc856082463b5$export$2e2bcd8739ae039 = $d24fc856082463b5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $c5ae669420cf1e4a$var$locale = {
    code: 'ru',
    formatDistance: (0, $9ddb1e7b3e4b0f55$export$2e2bcd8739ae039),
    formatLong: (0, $e3b8e8667b5854d5$export$2e2bcd8739ae039),
    formatRelative: (0, $bab93de8dcdee896$export$2e2bcd8739ae039),
    localize: (0, $74008c60c6ad6ba7$export$2e2bcd8739ae039),
    match: (0, $d24fc856082463b5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c5ae669420cf1e4a$export$2e2bcd8739ae039 = $c5ae669420cf1e4a$var$locale;
module.exports["default"] = $c5ae669420cf1e4a$export$2e2bcd8739ae039;

});

parcelRegister("hVF75", function(module, exports) {
var $498e3ea7400c79cd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: 'en sekund',
        other: '{{count}} sekunder'
    },
    halfAMinute: 'en halv minut',
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: 'en minut',
        other: '{{count}} minuter'
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: 'en timme',
        other: '{{count}} timmar'
    },
    xDays: {
        one: 'en dag',
        other: '{{count}} dagar'
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: 'en vecka',
        other: '{{count}} vecka'
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $498e3ea7400c79cd$var$wordMapping = [
    'noll',
    'en',
    "tv\xe5",
    'tre',
    'fyra',
    'fem',
    'sex',
    'sju',
    "\xe5tta",
    'nio',
    'tio',
    'elva',
    'tolv'
];
var $498e3ea7400c79cd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $498e3ea7400c79cd$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace('{{count}}', String(count));
    else result = tokenValue.other.replace('{{count}}', count < 13 ? $498e3ea7400c79cd$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'om ' + result;
        else return result + ' sedan';
    }
    return result;
};
var $498e3ea7400c79cd$export$2e2bcd8739ae039 = $498e3ea7400c79cd$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $aac8d4f534e9817e$var$dateFormats = {
    full: 'EEEE d MMMM y',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'y-MM-dd'
};
var $aac8d4f534e9817e$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $aac8d4f534e9817e$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $aac8d4f534e9817e$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $aac8d4f534e9817e$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $aac8d4f534e9817e$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $aac8d4f534e9817e$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $aac8d4f534e9817e$export$2e2bcd8739ae039 = $aac8d4f534e9817e$var$formatLong;


var $5924ed9d0ef7328b$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: 'P'
};
var $5924ed9d0ef7328b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5924ed9d0ef7328b$var$formatRelativeLocale[token];
};
var $5924ed9d0ef7328b$export$2e2bcd8739ae039 = $5924ed9d0ef7328b$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $96f1e67ab010045a$var$eraValues = {
    narrow: [
        'f.Kr.',
        'e.Kr.'
    ],
    abbreviated: [
        'f.Kr.',
        'e.Kr.'
    ],
    wide: [
        "f\xf6re Kristus",
        'efter Kristus'
    ]
};
var $96f1e67ab010045a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1:a kvartalet',
        '2:a kvartalet',
        '3:e kvartalet',
        '4:e kvartalet'
    ]
};
var $96f1e67ab010045a$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'jan.',
        'feb.',
        'mars',
        'apr.',
        'maj',
        'juni',
        'juli',
        'aug.',
        'sep.',
        'okt.',
        'nov.',
        'dec.'
    ],
    wide: [
        'januari',
        'februari',
        'mars',
        'april',
        'maj',
        'juni',
        'juli',
        'augusti',
        'september',
        'oktober',
        'november',
        'december'
    ]
};
var $96f1e67ab010045a$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'O',
        'T',
        'F',
        'L'
    ],
    short: [
        "s\xf6",
        "m\xe5",
        'ti',
        'on',
        'to',
        'fr',
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        'tis',
        'ons',
        'tors',
        'fre',
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        'tisdag',
        'onsdag',
        'torsdag',
        'fredag',
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $96f1e67ab010045a$var$dayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morg.',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    abbreviated: {
        am: 'f.m.',
        pm: 'e.m.',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'efterm.',
        evening: "kv\xe4ll",
        night: 'natt'
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: 'eftermiddag',
        midnight: 'midnatt',
        noon: 'middag',
        morning: 'morgon',
        afternoon: 'eftermiddag',
        evening: "kv\xe4ll",
        night: 'natt'
    }
};
var $96f1e67ab010045a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: 'fm',
        pm: 'em',
        midnight: 'midnatt',
        noon: 'middag',
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $96f1e67ab010045a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ':a';
    }
    return number + ':e';
};
var $96f1e67ab010045a$var$localize = {
    ordinalNumber: $96f1e67ab010045a$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $96f1e67ab010045a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $96f1e67ab010045a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $96f1e67ab010045a$export$2e2bcd8739ae039 = $96f1e67ab010045a$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $6df147ff21c266cb$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $6df147ff21c266cb$var$parseOrdinalNumberPattern = /\d+/i;
var $6df147ff21c266cb$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $6df147ff21c266cb$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $6df147ff21c266cb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $6df147ff21c266cb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6df147ff21c266cb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $6df147ff21c266cb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $6df147ff21c266cb$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $6df147ff21c266cb$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $6df147ff21c266cb$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $6df147ff21c266cb$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $6df147ff21c266cb$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6df147ff21c266cb$var$matchOrdinalNumberPattern,
        parsePattern: $6df147ff21c266cb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6df147ff21c266cb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6df147ff21c266cb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6df147ff21c266cb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6df147ff21c266cb$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6df147ff21c266cb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6df147ff21c266cb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6df147ff21c266cb$export$2e2bcd8739ae039 = $6df147ff21c266cb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $d0d7a6cbbd9931e0$var$locale = {
    code: 'sv',
    formatDistance: (0, $498e3ea7400c79cd$export$2e2bcd8739ae039),
    formatLong: (0, $aac8d4f534e9817e$export$2e2bcd8739ae039),
    formatRelative: (0, $5924ed9d0ef7328b$export$2e2bcd8739ae039),
    localize: (0, $96f1e67ab010045a$export$2e2bcd8739ae039),
    match: (0, $6df147ff21c266cb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $d0d7a6cbbd9931e0$export$2e2bcd8739ae039 = $d0d7a6cbbd9931e0$var$locale;
module.exports["default"] = $d0d7a6cbbd9931e0$export$2e2bcd8739ae039;

});

parcelRegister("9B6Ao", function(module, exports) {
var $fdb8e6ac6a228317$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
var $fdb8e6ac6a228317$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $fdb8e6ac6a228317$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === 'halfAMinute') return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
var $fdb8e6ac6a228317$export$2e2bcd8739ae039 = $fdb8e6ac6a228317$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $47a391d98d38a9f6$var$dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: 'do MMMM y',
    medium: 'd MMM y',
    short: 'dd/MM/yyyy'
};
var $47a391d98d38a9f6$var$timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
var $47a391d98d38a9f6$var$dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $47a391d98d38a9f6$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $47a391d98d38a9f6$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $47a391d98d38a9f6$var$timeFormats,
        defaultWidth: 'medium'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $47a391d98d38a9f6$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $47a391d98d38a9f6$export$2e2bcd8739ae039 = $47a391d98d38a9f6$var$formatLong;


var $a6ce4e8b6d5e4459$var$formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: 'P'
};
var $a6ce4e8b6d5e4459$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a6ce4e8b6d5e4459$var$formatRelativeLocale[token];
};
var $a6ce4e8b6d5e4459$export$2e2bcd8739ae039 = $a6ce4e8b6d5e4459$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $9ac7c6950e5d8543$var$eraValues = {
    narrow: [
        'B',
        "\u0E04\u0E28"
    ],
    abbreviated: [
        'BC',
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
var $9ac7c6950e5d8543$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
var $9ac7c6950e5d8543$var$dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
var $9ac7c6950e5d8543$var$monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
var $9ac7c6950e5d8543$var$dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $9ac7c6950e5d8543$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $9ac7c6950e5d8543$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $9ac7c6950e5d8543$var$localize = {
    ordinalNumber: $9ac7c6950e5d8543$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $9ac7c6950e5d8543$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $9ac7c6950e5d8543$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $9ac7c6950e5d8543$export$2e2bcd8739ae039 = $9ac7c6950e5d8543$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $977bde944afc485c$var$matchOrdinalNumberPattern = /^\d+/i;
var $977bde944afc485c$var$parseOrdinalNumberPattern = /\d+/i;
var $977bde944afc485c$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var $977bde944afc485c$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var $977bde944afc485c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var $977bde944afc485c$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var $977bde944afc485c$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var $977bde944afc485c$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var $977bde944afc485c$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var $977bde944afc485c$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var $977bde944afc485c$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var $977bde944afc485c$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var $977bde944afc485c$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $977bde944afc485c$var$matchOrdinalNumberPattern,
        parsePattern: $977bde944afc485c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $977bde944afc485c$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $977bde944afc485c$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $977bde944afc485c$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $977bde944afc485c$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $977bde944afc485c$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $977bde944afc485c$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $977bde944afc485c$export$2e2bcd8739ae039 = $977bde944afc485c$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var $6fccad97c533cd7b$var$locale = {
    code: 'th',
    formatDistance: (0, $fdb8e6ac6a228317$export$2e2bcd8739ae039),
    formatLong: (0, $47a391d98d38a9f6$export$2e2bcd8739ae039),
    formatRelative: (0, $a6ce4e8b6d5e4459$export$2e2bcd8739ae039),
    localize: (0, $9ac7c6950e5d8543$export$2e2bcd8739ae039),
    match: (0, $977bde944afc485c$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $6fccad97c533cd7b$export$2e2bcd8739ae039 = $6fccad97c533cd7b$var$locale;
module.exports["default"] = $6fccad97c533cd7b$export$2e2bcd8739ae039;

});

parcelRegister("azkPO", function(module, exports) {
var $cacaec45b7fe35c8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'bir saniyeden az',
        other: '{{count}} saniyeden az'
    },
    xSeconds: {
        one: '1 saniye',
        other: '{{count}} saniye'
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: 'bir dakikadan az',
        other: '{{count}} dakikadan az'
    },
    xMinutes: {
        one: '1 dakika',
        other: '{{count}} dakika'
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: '1 saat',
        other: '{{count}} saat'
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: '1 hafta',
        other: '{{count}} hafta'
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: '1 ay',
        other: '{{count}} ay'
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var $cacaec45b7fe35c8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cacaec45b7fe35c8$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + ' sonra';
        else return result + " \xf6nce";
    }
    return result;
};
var $cacaec45b7fe35c8$export$2e2bcd8739ae039 = $cacaec45b7fe35c8$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $145ecbfb5001ed36$var$dateFormats = {
    full: 'd MMMM y EEEE',
    long: 'd MMMM y',
    medium: 'd MMM y',
    short: 'dd.MM.yyyy'
};
var $145ecbfb5001ed36$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $145ecbfb5001ed36$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $145ecbfb5001ed36$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $145ecbfb5001ed36$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $145ecbfb5001ed36$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $145ecbfb5001ed36$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $145ecbfb5001ed36$export$2e2bcd8739ae039 = $145ecbfb5001ed36$var$formatLong;


var $b503168688c0db0e$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: 'P'
};
var $b503168688c0db0e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b503168688c0db0e$var$formatRelativeLocale[token];
};
var $b503168688c0db0e$export$2e2bcd8739ae039 = $b503168688c0db0e$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $e42b862c14382cbc$var$eraValues = {
    narrow: [
        "M\xd6",
        'MS'
    ],
    abbreviated: [
        "M\xd6",
        'MS'
    ],
    wide: [
        "Milattan \xd6nce",
        'Milattan Sonra'
    ]
};
var $e42b862c14382cbc$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $e42b862c14382cbc$var$monthValues = {
    narrow: [
        'O',
        "\u015E",
        'M',
        'N',
        'M',
        'H',
        'T',
        'A',
        'E',
        'E',
        'K',
        'A'
    ],
    abbreviated: [
        'Oca',
        "\u015Eub",
        'Mar',
        'Nis',
        'May',
        'Haz',
        'Tem',
        "A\u011Fu",
        'Eyl',
        'Eki',
        'Kas',
        'Ara'
    ],
    wide: [
        'Ocak',
        "\u015Eubat",
        'Mart',
        'Nisan',
        "May\u0131s",
        'Haziran',
        'Temmuz',
        "A\u011Fustos",
        "Eyl\xfcl",
        'Ekim',
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var $e42b862c14382cbc$var$dayValues = {
    narrow: [
        'P',
        'P',
        'S',
        "\xc7",
        'P',
        'C',
        'C'
    ],
    short: [
        'Pz',
        'Pt',
        'Sa',
        "\xc7a",
        'Pe',
        'Cu',
        'Ct'
    ],
    abbreviated: [
        'Paz',
        'Pzt',
        'Sal',
        "\xc7ar",
        'Per',
        'Cum',
        'Cts'
    ],
    wide: [
        'Pazar',
        'Pazartesi',
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        'Cuma',
        'Cumartesi'
    ]
};
var $e42b862c14382cbc$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: 'sabah',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: 'gece'
    }
};
var $e42b862c14382cbc$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: 'gy',
        noon: "\xf6",
        morning: 'sa',
        afternoon: "\xf6s",
        evening: 'ak',
        night: 'ge'
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: 'sabahleyin',
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: 'geceleyin'
    }
};
var $e42b862c14382cbc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + '.';
};
var $e42b862c14382cbc$var$localize = {
    ordinalNumber: $e42b862c14382cbc$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $e42b862c14382cbc$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $e42b862c14382cbc$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $e42b862c14382cbc$export$2e2bcd8739ae039 = $e42b862c14382cbc$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $5c60a0b40bcb1aee$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $5c60a0b40bcb1aee$var$parseOrdinalNumberPattern = /\d+/i;
var $5c60a0b40bcb1aee$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $5c60a0b40bcb1aee$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $5c60a0b40bcb1aee$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $5c60a0b40bcb1aee$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $5c60a0b40bcb1aee$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $5c60a0b40bcb1aee$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $5c60a0b40bcb1aee$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var $5c60a0b40bcb1aee$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var $5c60a0b40bcb1aee$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $5c60a0b40bcb1aee$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $5c60a0b40bcb1aee$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $5c60a0b40bcb1aee$var$matchOrdinalNumberPattern,
        parsePattern: $5c60a0b40bcb1aee$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c60a0b40bcb1aee$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c60a0b40bcb1aee$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c60a0b40bcb1aee$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $5c60a0b40bcb1aee$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $5c60a0b40bcb1aee$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $5c60a0b40bcb1aee$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $5c60a0b40bcb1aee$export$2e2bcd8739ae039 = $5c60a0b40bcb1aee$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $7b1d559a8c68f8a5$var$locale = {
    code: 'tr',
    formatDistance: (0, $cacaec45b7fe35c8$export$2e2bcd8739ae039),
    formatLong: (0, $145ecbfb5001ed36$export$2e2bcd8739ae039),
    formatRelative: (0, $b503168688c0db0e$export$2e2bcd8739ae039),
    localize: (0, $e42b862c14382cbc$export$2e2bcd8739ae039),
    match: (0, $5c60a0b40bcb1aee$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $7b1d559a8c68f8a5$export$2e2bcd8739ae039 = $7b1d559a8c68f8a5$var$locale;
module.exports["default"] = $7b1d559a8c68f8a5$export$2e2bcd8739ae039;

});

parcelRegister("baKKw", function(module, exports) {
function $01442f3194056974$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace('{{count}}', String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace('{{count}}', String(count));
    else return scheme.pluralGenitive.replace('{{count}}', String(count));
}
function $01442f3194056974$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $01442f3194056974$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $01442f3194056974$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $01442f3194056974$var$declension(scheme.past, count);
                else return $01442f3194056974$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $01442f3194056974$var$declension(scheme.regular, count);
    };
}
var $01442f3194056974$var$halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var $01442f3194056974$var$formatDistanceLocale = {
    lessThanXSeconds: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $01442f3194056974$var$halfAtMinute,
    lessThanXMinutes: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $01442f3194056974$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var $01442f3194056974$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $01442f3194056974$var$formatDistanceLocale[token](count, options);
};
var $01442f3194056974$export$2e2bcd8739ae039 = $01442f3194056974$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $9975c85ba013e980$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: 'dd.MM.y'
};
var $9975c85ba013e980$var$timeFormats = {
    full: 'H:mm:ss zzzz',
    long: 'H:mm:ss z',
    medium: 'H:mm:ss',
    short: 'H:mm'
};
var $9975c85ba013e980$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $9975c85ba013e980$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $9975c85ba013e980$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $9975c85ba013e980$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $9975c85ba013e980$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $9975c85ba013e980$export$2e2bcd8739ae039 = $9975c85ba013e980$var$formatLong;



var $dkBOe = parcelRequire("dkBOe");


var $gQ473 = parcelRequire("gQ473");

var $c61e346a95348094$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $c61e346a95348094$var$lastWeek(day) {
    var weekday = $c61e346a95348094$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $c61e346a95348094$var$thisWeek(day) {
    var weekday = $c61e346a95348094$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $c61e346a95348094$var$nextWeek(day) {
    var weekday = $c61e346a95348094$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var $c61e346a95348094$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $c61e346a95348094$var$thisWeek(day);
    else return $c61e346a95348094$var$lastWeek(day);
};
var $c61e346a95348094$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $dkBOe.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $gQ473.default)(date, baseDate, options)) return $c61e346a95348094$var$thisWeek(day);
    else return $c61e346a95348094$var$nextWeek(day);
};
var $c61e346a95348094$var$formatRelativeLocale = {
    lastWeek: $c61e346a95348094$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $c61e346a95348094$var$nextWeekFormat,
    other: 'P'
};
var $c61e346a95348094$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $c61e346a95348094$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $c61e346a95348094$export$2e2bcd8739ae039 = $c61e346a95348094$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $219d7b23715b11fd$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var $219d7b23715b11fd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $219d7b23715b11fd$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var $219d7b23715b11fd$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var $219d7b23715b11fd$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $219d7b23715b11fd$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var $219d7b23715b11fd$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var $219d7b23715b11fd$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === 'date') {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === 'minute' || unit === 'second' || unit === 'hour') suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var $219d7b23715b11fd$var$localize = {
    ordinalNumber: $219d7b23715b11fd$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $219d7b23715b11fd$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $219d7b23715b11fd$var$dayPeriodValues,
        defaultWidth: 'any',
        formattingValues: $219d7b23715b11fd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $219d7b23715b11fd$export$2e2bcd8739ae039 = $219d7b23715b11fd$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $7d62d6198376001a$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var $7d62d6198376001a$var$parseOrdinalNumberPattern = /\d+/i;
var $7d62d6198376001a$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var $7d62d6198376001a$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $7d62d6198376001a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var $7d62d6198376001a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7d62d6198376001a$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var $7d62d6198376001a$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var $7d62d6198376001a$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var $7d62d6198376001a$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var $7d62d6198376001a$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var $7d62d6198376001a$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $7d62d6198376001a$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $7d62d6198376001a$var$matchOrdinalNumberPattern,
        parsePattern: $7d62d6198376001a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $7d62d6198376001a$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $7d62d6198376001a$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $7d62d6198376001a$export$2e2bcd8739ae039 = $7d62d6198376001a$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var $8224e45a8b2272f4$var$locale = {
    code: 'uk',
    formatDistance: (0, $01442f3194056974$export$2e2bcd8739ae039),
    formatLong: (0, $9975c85ba013e980$export$2e2bcd8739ae039),
    formatRelative: (0, $c61e346a95348094$export$2e2bcd8739ae039),
    localize: (0, $219d7b23715b11fd$export$2e2bcd8739ae039),
    match: (0, $7d62d6198376001a$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $8224e45a8b2272f4$export$2e2bcd8739ae039 = $8224e45a8b2272f4$var$locale;
module.exports["default"] = $8224e45a8b2272f4$export$2e2bcd8739ae039;

});

parcelRegister("28ZKr", function(module, exports) {
var $162fbc90404e8c33$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
var $162fbc90404e8c33$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $162fbc90404e8c33$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
var $162fbc90404e8c33$export$2e2bcd8739ae039 = $162fbc90404e8c33$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $218bb7c871cdc9e5$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: 'dd/MM/y'
};
var $218bb7c871cdc9e5$var$timeFormats = {
    full: 'HH:mm:ss zzzz',
    long: 'HH:mm:ss z',
    medium: 'HH:mm:ss',
    short: 'HH:mm'
};
var $218bb7c871cdc9e5$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: '{{date}} {{time}}',
    // ngày 25 tháng 08 năm 2017 23:25
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $218bb7c871cdc9e5$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $218bb7c871cdc9e5$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $218bb7c871cdc9e5$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $218bb7c871cdc9e5$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $218bb7c871cdc9e5$export$2e2bcd8739ae039 = $218bb7c871cdc9e5$var$formatLong;


var $575e1228ef7548e6$var$formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: 'P'
};
var $575e1228ef7548e6$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $575e1228ef7548e6$var$formatRelativeLocale[token];
};
var $575e1228ef7548e6$export$2e2bcd8739ae039 = $575e1228ef7548e6$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var $77ed00faca7972dd$var$eraValues = {
    narrow: [
        'TCN',
        'SCN'
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        'sau CN'
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var $77ed00faca7972dd$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var $77ed00faca7972dd$var$formattingQuarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $77ed00faca7972dd$var$monthValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'Thg 1',
        'Thg 2',
        'Thg 3',
        'Thg 4',
        'Thg 5',
        'Thg 6',
        'Thg 7',
        'Thg 8',
        'Thg 9',
        'Thg 10',
        'Thg 11',
        'Thg 12'
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var $77ed00faca7972dd$var$formattingMonthValues = {
    narrow: [
        '01',
        '02',
        '03',
        '04',
        '05',
        '06',
        '07',
        '08',
        '09',
        '10',
        '11',
        '12'
    ],
    abbreviated: [
        'thg 1',
        'thg 2',
        'thg 3',
        'thg 4',
        'thg 5',
        'thg 6',
        'thg 7',
        'thg 8',
        'thg 9',
        'thg 10',
        'thg 11',
        'thg 12'
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var $77ed00faca7972dd$var$dayValues = {
    narrow: [
        'CN',
        'T2',
        'T3',
        'T4',
        'T5',
        'T6',
        'T7'
    ],
    short: [
        'CN',
        'Th 2',
        'Th 3',
        'Th 4',
        'Th 5',
        'Th 6',
        'Th 7'
    ],
    abbreviated: [
        'CN',
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var $77ed00faca7972dd$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
var $77ed00faca7972dd$var$formattingDayPeriodValues = {
    narrow: {
        am: 'am',
        pm: 'pm',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: 'tr',
        morning: 'sg',
        afternoon: 'ch',
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: 'SA',
        pm: 'CH',
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
var $77ed00faca7972dd$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === 'quarter') // many news outlets use "quý I"...
    switch(number){
        case 1:
            return 'I';
        case 2:
            return 'II';
        case 3:
            return 'III';
        case 4:
            return 'IV';
    }
    else if (unit === 'day') // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3";
        // meaning 3rd day
        case 3:
            return "th\u1EE9 4";
        // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt";
    }
    else if (unit === 'week') {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === 'dayOfYear') {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var $77ed00faca7972dd$var$localize = {
    ordinalNumber: $77ed00faca7972dd$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$quarterValues,
        defaultWidth: 'wide',
        formattingValues: $77ed00faca7972dd$var$formattingQuarterValues,
        defaultFormattingWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$monthValues,
        defaultWidth: 'wide',
        formattingValues: $77ed00faca7972dd$var$formattingMonthValues,
        defaultFormattingWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $77ed00faca7972dd$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $77ed00faca7972dd$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $77ed00faca7972dd$export$2e2bcd8739ae039 = $77ed00faca7972dd$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $c38f2f5bc11a2ff1$var$matchOrdinalNumberPattern = /^(\d+)/i;
var $c38f2f5bc11a2ff1$var$parseOrdinalNumberPattern = /\d+/i;
var $c38f2f5bc11a2ff1$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var $c38f2f5bc11a2ff1$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var $c38f2f5bc11a2ff1$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var $c38f2f5bc11a2ff1$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var $c38f2f5bc11a2ff1$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var $c38f2f5bc11a2ff1$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var $c38f2f5bc11a2ff1$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var $c38f2f5bc11a2ff1$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var $c38f2f5bc11a2ff1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var $c38f2f5bc11a2ff1$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var $c38f2f5bc11a2ff1$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $c38f2f5bc11a2ff1$var$matchOrdinalNumberPattern,
        parsePattern: $c38f2f5bc11a2ff1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseMonthPatterns,
        defaultParseWidth: 'wide'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseDayPatterns,
        defaultParseWidth: 'wide'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $c38f2f5bc11a2ff1$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $c38f2f5bc11a2ff1$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $c38f2f5bc11a2ff1$export$2e2bcd8739ae039 = $c38f2f5bc11a2ff1$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var $18fc39feec97f3b9$var$locale = {
    code: 'vi',
    formatDistance: (0, $162fbc90404e8c33$export$2e2bcd8739ae039),
    formatLong: (0, $218bb7c871cdc9e5$export$2e2bcd8739ae039),
    formatRelative: (0, $575e1228ef7548e6$export$2e2bcd8739ae039),
    localize: (0, $77ed00faca7972dd$export$2e2bcd8739ae039),
    match: (0, $c38f2f5bc11a2ff1$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
var $18fc39feec97f3b9$export$2e2bcd8739ae039 = $18fc39feec97f3b9$var$locale;
module.exports["default"] = $18fc39feec97f3b9$export$2e2bcd8739ae039;

});

parcelRegister("8tIg4", function(module, exports) {
var $64685d06163f4317$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var $64685d06163f4317$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $64685d06163f4317$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
var $64685d06163f4317$export$2e2bcd8739ae039 = $64685d06163f4317$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $d45ad2904abf1f09$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $d45ad2904abf1f09$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $d45ad2904abf1f09$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $d45ad2904abf1f09$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $d45ad2904abf1f09$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $d45ad2904abf1f09$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $d45ad2904abf1f09$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $d45ad2904abf1f09$export$2e2bcd8739ae039 = $d45ad2904abf1f09$var$formatLong;



var $gQ473 = parcelRequire("gQ473");

function $f64cab475ab54b4e$var$checkWeek(date, baseDate, options) {
    var baseFormat = 'eeee p';
    if ((0, $gQ473.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var $f64cab475ab54b4e$var$formatRelativeLocale = {
    lastWeek: $f64cab475ab54b4e$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $f64cab475ab54b4e$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: 'PP p'
};
var $f64cab475ab54b4e$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $f64cab475ab54b4e$var$formatRelativeLocale[token];
    if (typeof format === 'function') return format(date, baseDate, options);
    return format;
};
var $f64cab475ab54b4e$export$2e2bcd8739ae039 = $f64cab475ab54b4e$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $520597e1b0add328$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $520597e1b0add328$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $520597e1b0add328$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $520597e1b0add328$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $520597e1b0add328$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $520597e1b0add328$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $520597e1b0add328$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number.toString() + "\u65E5";
        case 'hour':
            return number.toString() + "\u65F6";
        case 'minute':
            return number.toString() + "\u5206";
        case 'second':
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var $520597e1b0add328$var$localize = {
    ordinalNumber: $520597e1b0add328$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $520597e1b0add328$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $520597e1b0add328$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $520597e1b0add328$export$2e2bcd8739ae039 = $520597e1b0add328$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $6b642dbf07fc44d5$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $6b642dbf07fc44d5$var$parseOrdinalNumberPattern = /\d+/i;
var $6b642dbf07fc44d5$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $6b642dbf07fc44d5$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $6b642dbf07fc44d5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $6b642dbf07fc44d5$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $6b642dbf07fc44d5$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $6b642dbf07fc44d5$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $6b642dbf07fc44d5$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $6b642dbf07fc44d5$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $6b642dbf07fc44d5$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $6b642dbf07fc44d5$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $6b642dbf07fc44d5$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $6b642dbf07fc44d5$var$matchOrdinalNumberPattern,
        parsePattern: $6b642dbf07fc44d5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6b642dbf07fc44d5$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6b642dbf07fc44d5$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6b642dbf07fc44d5$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $6b642dbf07fc44d5$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $6b642dbf07fc44d5$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $6b642dbf07fc44d5$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $6b642dbf07fc44d5$export$2e2bcd8739ae039 = $6b642dbf07fc44d5$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $62c35cf1e9047798$var$locale = {
    code: 'zh-CN',
    formatDistance: (0, $64685d06163f4317$export$2e2bcd8739ae039),
    formatLong: (0, $d45ad2904abf1f09$export$2e2bcd8739ae039),
    formatRelative: (0, $f64cab475ab54b4e$export$2e2bcd8739ae039),
    localize: (0, $520597e1b0add328$export$2e2bcd8739ae039),
    match: (0, $6b642dbf07fc44d5$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $62c35cf1e9047798$export$2e2bcd8739ae039 = $62c35cf1e9047798$var$locale;
module.exports["default"] = $62c35cf1e9047798$export$2e2bcd8739ae039;

});

parcelRegister("bOvA7", function(module, exports) {
var $bc69bbf0d8b7f781$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $bc69bbf0d8b7f781$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $bc69bbf0d8b7f781$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $bc69bbf0d8b7f781$export$2e2bcd8739ae039 = $bc69bbf0d8b7f781$var$formatDistance;



var $fcGXP = parcelRequire("fcGXP");

var $3d6603e7605d7041$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: 'yyyy-MM-dd',
    short: 'yy-MM-dd'
};
var $3d6603e7605d7041$var$timeFormats = {
    full: 'zzzz a h:mm:ss',
    long: 'z a h:mm:ss',
    medium: 'a h:mm:ss',
    short: 'a h:mm'
};
var $3d6603e7605d7041$var$dateTimeFormats = {
    full: '{{date}} {{time}}',
    long: '{{date}} {{time}}',
    medium: '{{date}} {{time}}',
    short: '{{date}} {{time}}'
};
var $3d6603e7605d7041$var$formatLong = {
    date: (0, $fcGXP.default)({
        formats: $3d6603e7605d7041$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $fcGXP.default)({
        formats: $3d6603e7605d7041$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $fcGXP.default)({
        formats: $3d6603e7605d7041$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $3d6603e7605d7041$export$2e2bcd8739ae039 = $3d6603e7605d7041$var$formatLong;


var $d69cf0cd60e3d274$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: 'P'
};
var $d69cf0cd60e3d274$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d69cf0cd60e3d274$var$formatRelativeLocale[token];
};
var $d69cf0cd60e3d274$export$2e2bcd8739ae039 = $d69cf0cd60e3d274$var$formatRelative;



var $9v2ZC = parcelRequire("9v2ZC");

var $a7674353d7a65490$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $a7674353d7a65490$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var $a7674353d7a65490$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $a7674353d7a65490$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $a7674353d7a65490$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $a7674353d7a65490$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $a7674353d7a65490$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case 'date':
            return number + "\u65E5";
        case 'hour':
            return number + "\u6642";
        case 'minute':
            return number + "\u5206";
        case 'second':
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $a7674353d7a65490$var$localize = {
    ordinalNumber: $a7674353d7a65490$var$ordinalNumber,
    era: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $9v2ZC.default)({
        values: $a7674353d7a65490$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $a7674353d7a65490$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $a7674353d7a65490$export$2e2bcd8739ae039 = $a7674353d7a65490$var$localize;



var $cJpo8 = parcelRequire("cJpo8");


var $cIBX8 = parcelRequire("cIBX8");

var $3eef3ef16b54ac72$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $3eef3ef16b54ac72$var$parseOrdinalNumberPattern = /\d+/i;
var $3eef3ef16b54ac72$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $3eef3ef16b54ac72$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $3eef3ef16b54ac72$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $3eef3ef16b54ac72$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $3eef3ef16b54ac72$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $3eef3ef16b54ac72$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $3eef3ef16b54ac72$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $3eef3ef16b54ac72$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $3eef3ef16b54ac72$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $3eef3ef16b54ac72$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $3eef3ef16b54ac72$var$match = {
    ordinalNumber: (0, $cIBX8.default)({
        matchPattern: $3eef3ef16b54ac72$var$matchOrdinalNumberPattern,
        parsePattern: $3eef3ef16b54ac72$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3eef3ef16b54ac72$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3eef3ef16b54ac72$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3eef3ef16b54ac72$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $3eef3ef16b54ac72$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $cJpo8.default)({
        matchPatterns: $3eef3ef16b54ac72$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $3eef3ef16b54ac72$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $3eef3ef16b54ac72$export$2e2bcd8739ae039 = $3eef3ef16b54ac72$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $899cdcad6eb1a6ad$var$locale = {
    code: 'zh-TW',
    formatDistance: (0, $bc69bbf0d8b7f781$export$2e2bcd8739ae039),
    formatLong: (0, $3d6603e7605d7041$export$2e2bcd8739ae039),
    formatRelative: (0, $d69cf0cd60e3d274$export$2e2bcd8739ae039),
    localize: (0, $a7674353d7a65490$export$2e2bcd8739ae039),
    match: (0, $3eef3ef16b54ac72$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $899cdcad6eb1a6ad$export$2e2bcd8739ae039 = $899cdcad6eb1a6ad$var$locale;
module.exports["default"] = $899cdcad6eb1a6ad$export$2e2bcd8739ae039;

});


$parcel$global.rlb("3Xf9v")
//# sourceMappingURL=ConversationAssistantUI.c1c172d0.js.map
